import { useState, useEffect, useRef, useLayoutEffect } from "react";
import { useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import "./index.css";
import {
  ownerAccDetail,
  addOwnerAccTags,
  removeOwnerAccTags,
  setTags,
  getOwnerAccBalance,
  setshowsuccestoast,
  getOwnerAccStatitics,
  getOwnerAccWeekStatitics,
  ownerAccAddFavourite,
  ownerAccRemoveFavourite,
  updateOwnerDetails,
  addNewLabelOwner,
  removeNewLabelOwner,
} from "../../../../redux/features/owner/ownerAllVerification/ownerAllVerification";
import { formatAccountNumber } from "../../../../components/_utils/FormatAccountNumber/index";
import UniversalRefreshToast from "../../../../components/_utils/UniversalRefreshToast/index";
import BalanceLoader from "../../../../components/_utils/BalanceLoader";
import formatTotalBalance from "../../../../utils/formatTotalBalance";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { beneViewAllAcc } from "../../../../redux/features/beneficiary/beneAllVerification/beneAllVerification";
import MinimumBal from "../../../../components/_utils/MinimumBalance";
import OwnerAllStatement from "../OwnerAllStatement";
import CommonCalendar from "../../../../components/_utils/CommonCalendar";
import OwnerStatisticsGraph from "../../../../components/Accounts/OwnerAccounts/OwnerStatisticsGraph/index.jsx";
import GSTVerification from "../../../Settings/GSTDetails/index.jsx";
import PanVerification from "../../../Settings/PanVerification/index.jsx";
import OwnerAccountIFSC from "../OwnerAccountIFSC/index.jsx";
import Loader from "../../../../components/Loader/Index.jsx";
import SingleSelectDropDownComponent from "../../../../components/_utils/CommonDropdown/SingleSelectDropdown/index.jsx";
import TopNavSmallButton from "../../../../components/_utils/CommonButtons/TopNavSmallButton/index.jsx";
import ItemisedReportComponent from "../../../../components/Accounts/OwnerAccounts/ItemisedReport/index.jsx";
import IconRoundButton from "../../../../components/_utils/CommonButtons/IconRoundButton/index.jsx";
import TitleSubtitlePair from "../../../../components/_utils/TitleSubtitlePair/index.jsx";
import CommonBankLogo from "../../../../components/_utils/CommonBankLogo/index.jsx";
import SwitcherTabs from "../../../../components/_utils/CommonButtons/SwitcherTabs/index.jsx";
import CommonDetailCard from "../../../../components/_utils/CommonDetailCard/index.jsx";
import CommonContainerCard from "../../../../components/_utils/CommonContainerCard/index.jsx";
import TEXT from "../../../../../src/utils/globalText";
import SVGComponent from "../../../../components/_utils/SVGComponent/index.jsx";
import CommonAssignTagPopup from "../../../../components/_utils/CommonPopups/CommonAssignTagPoppup";
import CommonToast from "../../../../components/_utils/CommonToast";
import SmallPopupWithBulletPoint from "../../../../components/_utils/CommonSmallPopupWithBulletPoint";
import CardActionableButton from "../../../../components/_utils/CommonViewAllCard/CardSubComponent/CardActionableButton/index.jsx";
import ICONS from "../../../../assets/Icons/index.js";
import EditCommonPopup from "../../../../components/_utils/CommonPopups/CommonEditPopup/index.jsx";
import CommonInfoBox from "../../../../components/_utils/CommonInfoBox/index.jsx";
import SmallPopupWithInput from "../../../../components/_utils/CommonSmallPopupWithInput/index.jsx";
import FormatAmount from "../../../../components/_utils/FormatAmount/FormatAmount.js";
import LargePopupRedirect from "../../../../components/_utils/CommonPopups/CommonLargePopupRedirect/index.jsx";
import {
  GlobalConfiguration,
  IntervalConfiguration,
} from "../../../../utils/configurationProvider.js";
import CommonAssignLabelPopup from "../../../../components/_utils/CommonPopups/CommonAssignLabelPopup/index.jsx";
import ReminderFlowTypeModal from "../../../../components/_utils/ReminderFlowTypeModal/index.jsx";
import InternalTransactionViewAll from "../../../InternalTransactionMain/InternalTransactionViewAll/index.jsx";
import useServiceChecker from "../../../../components/ServiceChecker/index.jsx";
import Chips from "../../../../components/_utils/CommonButtons/Chips/index.jsx";
import TopNavComponent from "../../../../components/_utils/CommonTopNav/TopNavComponent/index.jsx";
import BeneficiaryTransactionViewall from "../../../Transactions/BeneficiaryTransactions/BeneficiaryTransactionViewall/index.jsx";

function OwnerDetailsPage(props) {
  const currentDate = new Date();
  currentDate.setDate(
    currentDate.getDate() - GlobalConfiguration?.lengthCheckOne,
  );
  const { beneViewAllAccData } = useSelector(
    (state) => state.beneAllVerification,
  );
  const [ensureAll] = useServiceChecker();
  const [loading, setLoading] = useState(true);
  const [showLabelsPopup, setShowLabelsPopup] = useState(false);
  const [viewStatementOpenPop, setViewstatementOpenPop] = useState(false);
  const [viewItemisedOpenPop, setViewItemisedOpenPop] = useState(false);
  const [selectedTagOpenPop, setSelectedTagOpenPop] = useState(false);
  const [ownerDetailData, setOwnerdetaildata] = useState([]);
  const [accId, setAccId] = useState("");
  const [currentConnectedBal, setCurrentConnectedBal] = useState("");
  const [prevConnectedBal, setPrevConnectedBal] = useState("");
  const [refreshedConnectedId, setRefreshedConnectedId] = useState("");
  const [showDetails, setShowDetails] = useState(true);
  const [showStatistics, setShowStatistics] = useState(false);
  const [showAssignedTags, setShowAssignedTags] = useState(false);
  const [openHistory, setOpenHistory] = useState(false);
  const [openBeneHistory, setOpenBeneHistory] = useState(false);
  const [newTags, setNewTags] = useState([]);
  const [existingTags, setExistingTags] = useState([]);
  const [AllTags, setAllTags] = useState([]);
  const [minBalance, setMinBalance] = useState(false);
  const [amount, setAmount] = useState(() => {
    const savedAmount = localStorage.getItem("minBalanceAmount");
    return savedAmount ? savedAmount : "";
  });

  // Dont remove
  // Start Date - 2025-11-01
  // End Date - 2025-11-07

  const [startDateState, setStartDateState] = useState(
    new Date(new Date().setDate(GlobalConfiguration?.lengthCheckOne)),
  );
  const [endDateState, setEndDateState] = useState(new Date());
  const [labels, setLabels] = useState([]);
  const [startDate, setStartDate] = useState(
    new Date(new Date().setDate(GlobalConfiguration?.lengthCheckOne)),
  );
  const [endDate, setEndDate] = useState(new Date());
  const haveName = newTags?.some((val) => val?.type === "ownerTags");
  const [amountRange, setAmountRange] = useState("Absolute (amount)");
  const [amountRangeValue, setAmountRangeValue] = useState("");
  const [investmentRateValue, setInvestmentRateValue] = useState(6.62);
  const [selectAmountRange, setSelectAmountRange] = useState(false);
  const [accountBalancesReportData, setAccountBalancesReportData] = useState(
    [],
  );
  const [accountBalancesReportAllData, setAccountBalancesReportAllData] =
    useState([]);
  const [accountBalancesReportWeekData, setAccountBalancesReportWeekData] =
    useState([]);
  const [
    accountBalancesReportWeekAllData,
    setAccountBalancesReportWeekAllData,
  ] = useState([]);
  const [accountBalancesReportError, setAccountBalancesReportError] =
    useState("");
  const [accountBalancesReportWeekError, setAccountBalancesReportWeekError] =
    useState("");
  const [infoState, setInfoState] = useState(false);
  const [missedIncomeGraphData, setMissedIncomeGraphData] = useState([
    0, 0, 0, 0, 0, 0, 0,
  ]);
  const [actualIncomeGraphData, setActualIncomeGraphData] = useState([
    0, 0, 0, 0, 0, 0, 0,
  ]);
  const [isFavTagExist, setIsFavTagExist] = useState(false);
  const infoRef = useRef(null);
  const [labelDetails, setLabelDetails] = useState([]);

  const [showGstPopup, setGstShowPopup] = useState(false);
  const [showPanPopup, setPanShowPopup] = useState(false);
  const [showIfscPopup, setIfscShowPopup] = useState(false);
  const labelActionDispatchedRef = useRef(false);
  const [showModal, setShowModal] = useState(false);
  const [showFavPopup, setFavShowPopup] = useState(false);
  const [isFavLoading, setIsFavLoading] = useState(false);
  const [showCreditLimitPopup, setShowCreditLimitPopup] = useState(false);
  const [creditLimitInput, setCreditLimitInput] = useState("");
  const [initialCreditLimit, setInitialCreditLimit] = useState("");
  const [isCreditLimitLoading, setIsCreditLimitLoading] = useState(false);
  const [accountTypeLoading, setAccountTypeLoading] = useState(false);
  const [accountTypePopup, setShowAccountTypePopup] = useState(false);
  const [selectedChipIndex, setSelectedChipIndex] = useState("");
  const [infoAmountPopup, setInfoAmountPopup] = useState(false);
  const [showMinimumLimitPopup, setShowMinimumLimitPopup] = useState(false);
  const [minimumLimitInput, setMinimumLimitInput] = useState("");
  const [initialMinimumLimit, setInitialMinimumLimit] = useState("");
  const [isMinimumLimitLoading, setIsMinimumLimitLoading] = useState(false);
  const [showMaximumLimitPopup, setShowMaximumLimitPopup] = useState(false);
  const [maximumLimitInput, setMaximumLimitInput] = useState("");
  const [initialMaximumLimit, setInitialMaximumLimit] = useState("");
  const [isMaximumLimitLoading, setIsMaximumLimitLoading] = useState(false);

  const [index, setIndex] = useState(GlobalConfiguration?.lengthCheckZero);
  const [prevIndex, setPrevIndex] = useState(
    GlobalConfiguration?.lengthCheckZero,
  );
  const [animationClass, setAnimationClass] = useState("");
  const [balanceType, setBalanceType] = useState("credit");
  const [animateStatement, setAnimateStatement] = useState(false);
  const [animateItemised, setAnimateItemised] = useState(false);

  useLayoutEffect(() => {
    if (index !== prevIndex) {
      const direction =
        index > prevIndex ? "animate-slide-next" : "animate-slide-prev";

      setAnimationClass(direction);
      setPrevIndex(index);
    }
  }, [index]);

  const formatDate = (
    dateString,
    withComma = false,
    dateType = false,
    short = true,
  ) => {
    if (dateType) {
      let date = new Date(dateString);
      const day = String(date?.getDate()).padStart(
        GlobalConfiguration?.lengthCheckTwo,
        "0",
      );
      const month = String(
        date?.getMonth() + GlobalConfiguration?.lengthCheckOne,
      ).padStart(GlobalConfiguration?.lengthCheckTwo, "0");
      const year = date?.getFullYear();

      return day + "-" + month + "-" + year;
    } else {
      return `${dateString?.getDate()} ${dateString?.toLocaleString("default", {
        month: short ? "short" : "long",
      })}${withComma ? "," : ""} ${dateString?.getFullYear()}`;
    }
  };

  const {
    ownerAccBalanceLoading,
    ownerAccBalanceError,
    ownerAccountAvailabletags,
    showSuccessToast,
    removeOwnerAccTagsLoading,
    getOwnerAccStatiticsLoading,
    getOwnerAccWeekStatiticsLoading,
    ownerAccDetailData,
  } = useSelector((state) => state.ownerAllVerification);

  const services = useSelector((state) => state.refreshToken.services);

  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const getOwnerDetaildata = async () => {
    setLoading(true);

    try {
      let response;

      if (props?.popType == "ownerStatement") {
        response = await dispatch(ownerAccDetail(props?.ownerDetailId));
      } else if (props?.popType == "reimburseowner_details") {
        response = await dispatch(
          ownerAccDetail(props?.Remibursement_owneraccount_id),
        );
      } else {
        response = await dispatch(ownerAccDetail(id));
      }
      if (
        response?.payload?.owner_accounts?.length >
        GlobalConfiguration?.lengthCheckZero
      ) {
        setLabelDetails(response.payload.owner_accounts[0]?.labels || []);
      }
      // If response is empty or has an error, navigate to 404 page
      if (!response?.payload || response?.error?.status === 404) {
        navigate("/*");
        return;
      }

      dispatch(
        beneViewAllAcc({
          bank_account_no: response?.payload?.owner_accounts[0]?.bank_acc_no,
          ifsc: response?.payload?.owner_accounts[0]?.ifsc_code,
          pan: response?.payload?.owner_accounts[0]?.pan_no,
          type: "internalAccount",
        }),
      );

      setOwnerdetaildata(response?.payload?.owner_accounts[0]);
      setIsFavTagExist(
        (response?.payload?.owner_accounts[0]?.favourite ?? "N") === "Y",
      );

      if (
        response?.payload?.owner_accounts[0]?.tags &&
        response?.payload?.owner_accounts[0]?.tags.length >
          GlobalConfiguration?.lengthCheckZero
      ) {
        const data = response?.payload?.owner_accounts[0].tags?.map((res) => {
          return { selected: true, value: res, type: "ownerTags" };
        });

        setNewTags(data);
        setLoading(true);
      }

      setLoading(false);

      if (response?.error?.message == "Request failed with status code 404") {
        navigate("/*");
      }

      if (response?.payload === undefined) {
        navigate("/feature_not_assigned");
      }
    } catch (error) {
      setLoading(false);
      navigate("/*");
    }
  };

  const shouldBeRedacted = (price) => {
    return (
      price === "xxxx.xx" ||
      isNaN(+price) ||
      price === null ||
      price === undefined
    );
  };
  useEffect(() => {
    getOwnerDetaildata();
    if (
      ownerAccountAvailabletags?.length === GlobalConfiguration?.lengthCheckZero
    ) {
      const availableTags = sessionStorage.getItem("AvailableTags");
      if (availableTags) {
        dispatch(setTags(JSON.parse(availableTags, ...newTags)));
      }
    }
  }, [id]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (infoRef.current && !infoRef.current.contains(event.target)) {
        setInfoState(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);
  const handleAddTags = async (item) => {
    try {
      const selectedTags = newTags
        .filter((tag) => tag.selected === false)
        .map((tag) => tag.value);

      try {
      } catch (error) {}

      let response = await dispatch(
        addOwnerAccTags({
          owner_id: [id],
          tags: item?.type === "newAss" ? item?.data1 : [item],
        }),
      );

      if (response?.payload?.status === true) {
        getOwnerDetaildata();
        setNewTags((prev) => [...prev, response?.meta?.arg?.tags]);
      } else {
        setLoading(false);
        CommonToast({
          text: response?.payload?.message,
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const handleRemoveTags = async (item) => {
    setLoading(true);
    if (removeOwnerAccTagsLoading) {
      setLoading(true);
    }

    try {
      let param = Array.isArray(item) ? item : [item];
      const response = await dispatch(
        removeOwnerAccTags({ owner_id: [id], tags: param }),
      );

      if (response?.payload?.status === true) {
        getOwnerDetaildata();
        setNewTags(response?.payload?.tags?.value || []);
        setLoading(false);
      } else {
        setLoading(false);
        // CommonToast({
        //   text: response?.payload?.message,
        //   icon: ICONS?.ERROR_WHITE_CIRCLE,
        //   variant: "var(--error)",
        //   buttonNeeded: false,
        // });
      }
    } catch (error) {
      setLoading(false);
      console.error("Error removing tag:", error);
    }
  };

  const handleRefresh = async (ownerid) => {
    setRefreshedConnectedId(id);
    try {
      let response = await dispatch(getOwnerAccBalance(ownerid));
      if (response?.payload?.status == true) {
        setPrevConnectedBal(ownerDetailData?.owner_account_balance);
        setCurrentConnectedBal(
          response?.payload?.owner_accounts[0]?.owner_account_balance,
        );

        setOwnerdetaildata((prevState) => {
          return {
            ...prevState,
            owner_account_balance_last_fetched_at_in_words:
              response?.payload?.owner_accounts[0]
                ?.owner_account_balance_last_fetched_at_in_words,
            owner_account_balance:
              response?.payload?.owner_accounts[0]?.owner_account_balance,
            owner_account_balance_last_fetched_at:
              response.payload?.owner_accounts[0]
                .owner_account_balance_last_fetched_at,
            difference: Math.abs(
              Number(prevState.owner_account_balance) -
                Number(
                  response.payload.owner_accounts[0].owner_account_balance,
                ),
            ),
            increaseOrDecrease:
              Number(prevState.owner_account_balance) >
              Number(response.payload.owner_accounts[0].owner_account_balance)
                ? "decreased"
                : Number(prevState.owner_account_balance) <
                    Number(
                      response.payload.owner_accounts[0].owner_account_balance,
                    )
                  ? "increased"
                  : "",
          };
        });
      } else {
        setTimeout(() => {
          toast.dismiss();

          const errorMessage =
            response?.payload?.response?.data?.errors?.base?.[0] ||
            response?.payload?.message ||
            "Something went wrong";

          CommonToast({
            text: errorMessage,
            icon: ICONS?.ERROR_WHITE_CIRCLE,
            variant: "var(--error)",
            btnProps: {
              isDisabled: false,
              enabledTextColor: "var(--text-primary)",
              enabledBgColor: "var(--primary-bg)",
            },
          });
        }, 500);
      }
    } catch (error) {
      CommonToast({
        text: error,
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      throw error;
    }
  };

  const showToast = (message) => {
    CommonToast({
      text: message,
      icon: "https://q2pay.in/new_assets/gifs/inputloader_white.gif",
      variant: "var(--processing)",
      buttonNeeded: false,
      btnProps: {
        enabledBgColor: "var(--primary-bg)",
        enabledTextColor: "var(--text-primary)",
        btnText: "",
        handleFunction: () => {},
        icon: "",
        btnType: "button",
        isDisabled: false,
        hoverOption: "white",
      },
    });
  };

  const handleFavourite = async () => {
    setIsFavLoading(true);
    showToast(
      isFavTagExist ? "Removing from favourite" : "Setting to favourite",
    );

    let res;
    if (isFavTagExist) {
      res = await dispatch(ownerAccRemoveFavourite(ownerDetailData.id));
      if (res?.payload?.status) {
        toast.dismiss();
        CommonToast({
          text: "Removed from favourite successfully.",
          icon: "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg",
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });

        setIsFavTagExist(false);
        setFavShowPopup(false);
      }
    } else {
      res = await dispatch(ownerAccAddFavourite(ownerDetailData.id));
      if (res?.payload?.status) {
        toast.dismiss();
        CommonToast({
          text: "Favourite set successfully.",
          icon: "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg",
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });

        setIsFavTagExist(true);
        setFavShowPopup(false);
      }
    }
    setIsFavLoading(false);
  };

  const handleCloseModal = () => {
    setViewstatementOpenPop(false);
    setSelectedTagOpenPop(false);
    setNewTags((prev) => {
      return [...prev].map((result) => {
        return { selected: true, value: result?.value, type: result?.type };
      });
    });
  };
  const handleSelectedtag = () => {
    setSelectedTagOpenPop(true);
  };

  const handleViewStatement = () => {
    setViewstatementOpenPop(true);
  };

  useEffect(() => {
    if (ownerAccBalanceLoading && !openHistory) {
      UniversalRefreshToast();
    }

    if (!ownerAccBalanceLoading && !ownerAccBalanceError) {
      setTimeout(() => {
        toast.dismiss();

        if (showSuccessToast && !openHistory) {
          setTimeout(() => {
            CommonToast({
              text: "Balance refreshed successfully.",
              icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
              variant: "var(--success)",
              btnProps: {
                isDisabled: false,
                enabledTextColor: "var(--text-primary)",
                enabledBgColor: "var(--primary-bg)",
              },
            });

            dispatch(setshowsuccestoast());
          }, 250);
        }
      }, 500);
    }
  }, [ownerAccBalanceLoading]);

  const toggleDetails = () => {
    setShowDetails(true);
    setShowStatistics(false);
    setShowAssignedTags(false);
  };

  const toggleStatistics = () => {
    setShowDetails(false);
    setShowStatistics(true);
    setShowAssignedTags(false);
    if (!showStatistics) {
      setStartDateState(
        new Date(new Date().setDate(GlobalConfiguration?.lengthCheckOne)),
      );
      // setEndDateState(currentDate);
      setEndDateState(new Date());
      setStartDate(
        new Date(new Date().setDate(GlobalConfiguration?.lengthCheckOne)),
      );
      setEndDate(new Date());
    }
  };

  const toggleAdditionalDetails = () => {
    setShowAssignedTags(true);
    setShowStatistics(false);
    setShowDetails(false);
  };

  const toggleLabelDetails = () => {
    setShowAssignedTags(false);
    setShowStatistics(false);
    setShowDetails(false);
  };

  const isArchived =
    ownerAccDetail?.beneficiary_accounts?.approval_status === "archived";

  const hasALabel = services?.includes("ALabel");
  const hasRLabel = services?.includes("RLabel");

  const isServiceMissing = !(hasALabel && hasRLabel);

  const handleClick = () => {
    if (isArchived) return;
    if (
      props?.popType == "ownerStatement" ||
      props?.popType == "reimburseowner_details"
    ) {
      CommonToast({
        text: "Action restricted in popup mode.",
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
      });
    } else if (isServiceMissing) {
      navigate("/feature_not_assigned", {
        state: { unavailableService: "ALabel,RLabel" },
      });
    } else {
      setShowLabelsPopup(true);
    }
  };

  const handleClose = () => {
    setShowLabelsPopup(false);
    if (labelActionDispatchedRef.current) {
      getOwnerDetaildata();
    }
  };

  useEffect(() => {
    let availableLabels = sessionStorage?.getItem("AvailableLabelsOwner");
    const parsedLabels = JSON?.parse(availableLabels);
    setLabels(parsedLabels);
  }, [ownerDetailData?.id]);

  // Statistics Logic Start ---------------------------

  const handleWeekData = (weekData, pastSevenDates) => {
    const updatedData = [...missedIncomeGraphData];

    pastSevenDates.forEach((item, index) => {
      const specDate = new Date(item);

      // Find the matching week date
      const matchedWeekData = weekData.find((data) => {
        const weekDate = new Date(data?.date);
        return (
          specDate.getDate() === weekDate.getDate() &&
          specDate.getMonth() === weekDate.getMonth() &&
          specDate.getFullYear() === weekDate.getFullYear()
        );
      });

      // If a match is found, use its daily_interest, else 0
      if (matchedWeekData) {
        if (amountRangeValue !== "") {
          updatedData[index] = formatTotalBalance(
            matchedWeekData?.daily_interest,
            amountRangeValue,
          ).amount;
        } else {
          updatedData[index] = matchedWeekData?.daily_interest;
        }
      } else {
        updatedData[index] = 0;
      }
    });

    setMissedIncomeGraphData(updatedData);
  };

  const handleStatisticsData = async (
    start_Date,
    end_Date,
    interest_rate,
    type = "week",
  ) => {
    try {
      let reportData = [];

      const handleResponse = (response, isWeek) => {
        if (response?.payload?.status === true) {
          reportData =
            response?.payload?.owner_account_details?.account_balances_report;

          if (isWeek) {
            setAccountBalancesReportWeekData(reportData);
            setAccountBalancesReportWeekAllData(response?.payload);
          } else {
            setAccountBalancesReportData(reportData);
            setAccountBalancesReportAllData(response?.payload);
          }
        } else {
          const error = response?.payload?.response?.data?.errors?.base?.[0];
          if (isWeek) {
            setAccountBalancesReportWeekData([]);
            setAccountBalancesReportWeekAllData([]);
            setAccountBalancesReportWeekError(error);
          } else {
            setAccountBalancesReportData([]);
            setAccountBalancesReportAllData([]);
            setAccountBalancesReportError(error);
          }
        }
      };

      let response;

      if (type !== "week") {
        response = await dispatch(
          getOwnerAccStatitics({
            id: id,
            start_date: start_Date,
            end_date: end_Date,
            // interest_rate: interest_rate,
          }),
        );
        handleResponse(response, false);
      } else {
        response = await dispatch(
          getOwnerAccWeekStatitics({
            id: id,
            start_date: start_Date,
            end_date: end_Date,
            // interest_rate: interest_rate,
          }),
        );
        handleResponse(response, true);
      }

      if (type === "week") {
        handleWeekData(reportData, pastSevenDates);
      }
    } catch (error) {
      CommonToast({
        text: error?.message,
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
    }
  };

  const handleDateChange2 = (dates) => {
    const [start, end] = dates;
    setStartDateState(start);
    setEndDateState(end);

    setStartDate(start);
    setEndDate(end);
  };

  useEffect(() => {
    handleStatisticsData(
      formatDate(sixDaysAgo),
      formatDate(yesterdaysDate),
      investmentRateValue,
      "week",
    );
  }, [investmentRateValue, amountRangeValue]);

  useEffect(() => {
    if (showStatistics) {
      handleStatisticsData(
        formatDate(startDateState),
        formatDate(endDateState),
        investmentRateValue,
        "month",
      );
    }
  }, [investmentRateValue, endDate, startDate, amountRangeValue]);

  function getPastSevenDaysDates() {
    // Six days ago
    const sixDaysAgo = new Date(currentDate);
    sixDaysAgo.setDate(currentDate.getDate() - 6);

    const yesterdaysDate = new Date(currentDate);

    // Function to format the date in "23 Feb" format
    const formatDateDays = (date) => {
      const day = date.getDate();
      const month = date.toLocaleString("default", { month: "short" }); // Get short month name
      return `${day} ${month}`;
    };

    const pastSevenDays = [];
    const pastSevenDates = [];
    for (let i = 0; i < 7; i++) {
      const date = new Date(sixDaysAgo);
      date.setDate(sixDaysAgo.getDate() + i);
      pastSevenDays.push(formatDateDays(date));
      pastSevenDates.push(date);
    }

    return {
      sixDaysAgo: sixDaysAgo,
      yesterdaysDate: yesterdaysDate,
      pastSevenDays: pastSevenDays,
      pastSevenDates: pastSevenDates,
    };
  }

  const { sixDaysAgo, yesterdaysDate, pastSevenDays, pastSevenDates } =
    getPastSevenDaysDates();

  // Statistics Logic End ---------------------------

  const closeDetailsModal = (type) => {
    switch (type) {
      case "gst":
        setGstShowPopup(false);
        break;
      case "ifsc":
        setIfscShowPopup(false);
        break;
      case "pan":
        setPanShowPopup(false);
        break;
      default:
    }
  };

  const accountType = (AccountType) => {
    switch (AccountType) {
      case "Overdraft Account":
        return "Overdraft (OD)";
      case "CACC":
        return "Cash credit (CC)";
      case "Current Account":
        return "Current account";
      case "Fixed Deposit Account":
        return "Fixed deposit (FD)";
      case "Salary Account":
        return "Salary account";
      default:
        return AccountType;
    }
  };

  const handleStatistics = () => {
    if (
      ownerDetailData?.connected_banking === "Y" &&
      (services?.includes("Admin") || services?.includes("VAccountBalance"))
    ) {
      toggleStatistics();
      if (showStatistics) {
        handleStatisticsData(
          formatDate(startDateState),
          formatDate(endDateState),
          investmentRateValue,
          "month",
        );

        handleStatisticsData(
          formatDate(sixDaysAgo),
          formatDate(yesterdaysDate),
          investmentRateValue,
          "week",
        );
      }
    } else if (
      ownerDetailData?.connected_banking === "Y" &&
      (!services?.includes("Admin") || !services?.includes("VAccountBalance"))
    ) {
      navigate("/feature_not_assigned", {
        state: {
          unavailableService: "VAccountBalance",
        },
      });
    }
  };

  const bankDetailsEntries = [
    {
      heading: "Account holder name",
      content: ownerDetailData?.name,
      type: "text",
    },
    {
      heading: "Account type",
      content: accountType(ownerDetailData?.account_type),
      iconArray: [
        {
          type: "indicator",
          title:
            ownerDetailData?.connected_banking === "Y" ? "Active" : "Inactive",
          bgColor:
            ownerDetailData?.connected_banking === "Y"
              ? "var(--settled)"
              : "var(--failed)",
          imgColor:
            ownerDetailData?.connected_banking === "Y"
              ? "var(--positive-bg)"
              : "var(--negative-bg)",
        },
        {
          type: "image",
          title: "Edit",
          icon: ICONS.EDIT,
          isDisabled:
            ownerDetailData?.account_type === "Overdraft Account" ||
            !services?.includes("UAccount"),
          onClick: () => {
            if (!services?.includes("UAccount")) {
              navigate("/feature_not_assigned", {
                state: { unavailableService: "UAccount" },
              });
            } else if (ownerDetailData?.account_type === "CACC") {
              CommonToast({
                text: "Cash Credit account cannot be changed",
                icon: ICONS?.ERROR_WHITE_CIRCLE,
                variant: "var(--error)",
                btnProps: {
                  isDisabled: false,
                  enabledTextColor: "var(--text-primary)",
                  enabledBgColor: "var(--primary-bg)",
                },
              });
            } else {
              setShowAccountTypePopup(
                ownerDetailData?.account_type !== "Overdraft Account" &&
                  ownerDetailData?.account_type !== "CACC",
              );
            }
          },
        },
      ],
      type: "textwithicon",
    },
  ];

  const ownerDetailsEntries = [
    {
      heading: "PAN number",
      content: ownerDetailData?.pan_no,
      type: "text",
      onClick: () => {
        if (
          props?.popType == "ownerStatement" ||
          props?.popType == "reimburseowner_details"
        ) {
          CommonToast({
            text: "Action restricted in popup mode.",
            icon: ICONS?.ERROR_WHITE_CIRCLE,
            variant: "var(--error)",
          });
        } else if (services?.includes("VPAN")) {
          setPanShowPopup(true);
        } else {
          navigate("/feature_not_assigned", {
            state: { unavailableService: "VPAN" },
          });
        }
      },
      isDisabled:
        props?.popType == "ownerStatement" ||
        props?.popType == "reimburseowner_details" ||
        !services?.includes("VPAN"),
    },
    {
      heading: "GST number",
      content: ownerDetailData?.gstin_detail,
      type: "text",
      onClick: () => {
        if (
          props?.popType == "ownerStatement" ||
          props?.popType == "reimburseowner_details"
        ) {
          CommonToast({
            text: "Action restricted in popup mode.",
            icon: ICONS?.ERROR_WHITE_CIRCLE,
            variant: "var(--error)",
          });
        } else if (services?.includes("VGSTIN")) {
          setGstShowPopup(true);
        } else {
          navigate("/feature_not_assigned", {
            state: { unavailableService: "VGSTIN" },
          });
        }
      },
      isDisabled:
        props?.popType == "ownerStatement" ||
        props?.popType == "reimburseowner_details" ||
        !services?.includes("VGSTIN"),
    },
    // {
    //   heading: "Entity email ID",
    //   content: ownerDetailData?.email_id,
    //   type: "text",
    // },
  ];

  const supportDetailsEntries = [
    {
      heading: "Owner account ID",
      content: ownerDetailData?.id,
      type: "text",
    },
  ];

  const handleCreditLimit = async () => {
    if (!creditLimitInput || creditLimitInput === initialCreditLimit)
      return false;

    setIsCreditLimitLoading(true);
    showToast("Setting credit limit");

    const res = await dispatch(
      updateOwnerDetails({
        id: ownerDetailData?.id,
        od_limit: creditLimitInput,
      }),
    );
    if (res?.payload?.status) {
      setOwnerdetaildata(res?.payload?.owner_accounts?.[0]);
      const newCreditLimit = String(
        res?.payload?.owner_accounts?.[0]?.od_limit || "",
      );
      setInitialCreditLimit(newCreditLimit);
      toast.dismiss();
      CommonToast({
        text: "Credit limit set successfully.",
        icon: "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg",
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      setShowCreditLimitPopup(false);
    } else if (res?.error) {
      const errorMessage =
        res?.payload?.response?.data?.errors?.od_limit?.[0] ||
        "Currently unable to set credit limit";

      toast.dismiss();
      CommonToast({
        text: errorMessage,
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }
    setIsCreditLimitLoading(false);
    setShowCreditLimitPopup(false);
  };

  useEffect(() => {
    const currentLimit = ownerDetailData?.od_limit || "";
    const minCurrentLimit = ownerDetailData?.min_limit || "";
    const maxCurrentLimit = ownerDetailData?.max_limit || "";
    setMinimumLimitInput(String(minCurrentLimit));
    setInitialMinimumLimit(String(minCurrentLimit));
    setMaximumLimitInput(String(maxCurrentLimit));
    setInitialMaximumLimit(String(maxCurrentLimit));
    setCreditLimitInput(String(currentLimit));
    setInitialCreditLimit(String(currentLimit));
  }, [
    ownerDetailData?.od_limit,
    ownerDetailData?.min_limit,
    ownerDetailData?.max_limit,
  ]);

  const handleMinimumLimit = async () => {
    if (!minimumLimitInput || minimumLimitInput === initialMinimumLimit)
      return false;

    const minLimit = Number(minimumLimitInput);

    setIsMinimumLimitLoading(true);
    showToast("Updating minimum balance");

    const res = await dispatch(
      updateOwnerDetails({
        id: ownerDetailData?.id,
        min_limit: minLimit,
      }),
    );
    if (res?.payload?.status) {
      setOwnerdetaildata(res?.payload?.owner_accounts?.[0]);
      const newMinimumLimit = String(
        res?.payload?.owner_accounts?.[0]?.min_limit || "",
      );
      setInitialMinimumLimit(newMinimumLimit);
      toast.dismiss();
      CommonToast({
        text: "Updated minimum balance successfully.",
        icon: "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg",
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      setShowMinimumLimitPopup(false);
    } else {
      const errorMessage =
        res?.payload?.errors?.[0] || "Currently unable to set minimum limit";

      toast.dismiss();
      CommonToast({
        text: errorMessage,
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }
    setIsMinimumLimitLoading(false);
    setShowMinimumLimitPopup(false);
  };

  const handleMaximumLimit = async () => {
    if (!maximumLimitInput || maximumLimitInput === initialMaximumLimit)
      return false;

    const maxLimit = Number(maximumLimitInput);

    setIsMaximumLimitLoading(true);
    showToast("Updating auto sweep limit");

    const res = await dispatch(
      updateOwnerDetails({
        id: ownerDetailData?.id,
        max_limit: maxLimit,
      }),
    );
    if (res?.payload?.status) {
      setOwnerdetaildata(res?.payload?.owner_accounts?.[0]);
      const newMaximumLimit = String(
        res?.payload?.owner_accounts?.[0]?.max_limit || "",
      );
      setInitialMaximumLimit(newMaximumLimit);
      toast.dismiss();
      CommonToast({
        text: "Updated auto sweep limit",
        icon: "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg",
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      setShowMaximumLimitPopup(false);
    } else {
      const errorMessage =
        res?.payload?.errors?.[0] || "Currently unable to set minimum limit";

      toast.dismiss();
      CommonToast({
        text: errorMessage,
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }
    setIsMaximumLimitLoading(false);
    setShowMaximumLimitPopup(false);
  };

  const handleAccountType = async () => {
    if (selectedChipIndex === "") return;
    setAccountTypeLoading(true);
    showToast("Changing account type");
    const accountTypeMap = {
      1: "Current Account",
      2: "Overdraft Account",
      // 3: "Savings Account",
      // 4: "Salary Account",
      5: "Fixed Deposit Account",
      // 6: "Recurring Deposit Account",
      7: "CACC",
      // 8: "Other",
      // 9: "Export/Import account",  These are the extra fields as from design
      // 10: "Letter of credit (LC)",
      // 11: "Bank guarantee",
      // 12: "Escrow for M&A",
    };
    const selectedAccountType = accountTypeMap[selectedChipIndex];

    const res = await dispatch(
      updateOwnerDetails({
        id: ownerDetailData.id,
        type_of_account: selectedAccountType,
        od_limit:
          selectedAccountType === "Overdraft Account" ? "0.1" : undefined,
      }),
    );
    if (updateOwnerDetails.fulfilled.match(res)) {
      setOwnerdetaildata(res.payload.owner_accounts[0]);

      toast.dismiss();
      CommonToast({
        text: "Account type changed successfully.",
        icon: "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg",
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });

      setShowAccountTypePopup(false);
    } else {
      const errorMessage =
        res?.payload?.errors?.type_of_account?.[0] ||
        res?.payload?.errors?.base?.[0] ||
        "Account type cannot be changed";

      toast.dismiss();
      CommonToast({
        text: errorMessage,
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }
    setAccountTypeLoading(false);
    setSelectedChipIndex("");
    setShowAccountTypePopup(false);
  };

  const handleChipClick = (id) => {
    setSelectedChipIndex(id);
  };

  const chipsArray = [
    {
      text: "Current account",
      disabled:
        ownerDetailData?.account_type === "Current Account" ||
        ownerDetailData?.account_type === "CACC",
      hoverOption: "white",
      selected: selectedChipIndex === GlobalConfiguration?.lengthCheckOne,
      onClick: () => handleChipClick(GlobalConfiguration?.lengthCheckOne),
    },
    {
      text: "Overdraft (OD)",
      disabled:
        ownerDetailData?.account_type === "Overdraft Account" ||
        ownerDetailData?.account_type === "CACC" ||
        (ownerDetailData?.account_type !== "Current Account" &&
          ownerDetailData?.account_type !== "Overdraft Account"),
      hoverOption: "white",
      selected: selectedChipIndex === GlobalConfiguration?.lengthCheckTwo,
      onClick: () => handleChipClick(GlobalConfiguration?.lengthCheckTwo),
    },
    // {
    //   text: "Savings account",
    //   disabled:
    //     ownerDetailData?.account_type === "Savings Account" ? true : false,
    //   onClick: () => handleChipClick(3),
    //   selected: selectedChipIndex === 3,
    //   hoverOption: "white",
    // },
    // {
    //   text: "Salary account",
    //   disabled:
    //     ownerDetailData?.account_type === "Salary Account" ||
    //     (ownerDetailData?.account_type !== "Current Account" &&
    //       ownerDetailData?.account_type !== "Salary Account"),
    //   onClick: () => handleChipClick(4),
    //   selected: selectedChipIndex === 4,
    //   hoverOption: "white",
    // },
    {
      text: "Fixed deposit (FD)",
      disabled:
        ownerDetailData?.account_type === "Fixed Deposit Account" ||
        ownerDetailData?.account_type === "Current Account" ||
        ownerDetailData?.account_type !== "Fixed Deposit Account",
      onClick: () => handleChipClick(5),
      selected: selectedChipIndex === 5,
      hoverOption: "white",
    },
    // {
    //   text: "Recurring Deposit Account",
    //   disabled:
    //     ownerDetailData?.account_type === "Recurring Deposit Account"
    //       ? true
    //       : false,
    //   onClick: () => handleChipClick(6),
    //   selected: selectedChipIndex === 6,
    //   hoverOption: "white",
    // },
    {
      text: "Cash credit (CC)",
      disabled: ownerDetailData?.account_type === "CACC",
      onClick: () => handleChipClick(7),
      selected: selectedChipIndex === 7,
      hoverOption: "white",
    },
    // {
    //   text: "Other",
    //   disabled: ownerDetailData?.account_type === "Other" ? true : false,
    //   onClick: () => handleChipClick(8),
    //   selected: selectedChipIndex === 8,
    //   hoverOption: "white",
    // },
    // {
    //   text: "Escrow account",
    //   disabled: false,
    //   // onClick: () => handleChipClick(4),
    //   hoverOption: "white",
    // },
    // {
    //   text: "Nodal account",
    //   disabled: false,
    //   // onClick: () => handleChipClick(4),
    //   hoverOption: "white",
    // },
    // {
    //   text: "EEFC account",
    //   disabled: false,
    //   // onClick: () => handleChipClick(4),
    //   hoverOption: "white",
    // },
    // {
    //   text: "Export/Import account",
    //   disabled: false,
    //   // onClick: () => handleChipClick(4),
    //   hoverOption: "white",
    // },
    // {
    //   text: "Letter of credit (LC)",
    //   disabled: false,
    //   // onClick: () => handleChipClick(4),
    //   hoverOption: "white",
    // },
    // {
    //   text: "Bank guarantee",
    //   disabled: false,
    //   // onClick: () => handleChipClick(4),
    //   hoverOption: "white",
    // },
    // {
    //   text: "Escrow for M&A",
    //   disabled: false,
    //   // onClick: () => handleChipClick(4),
    //   hoverOption: "white",
    // },
  ];

  const handleAssignLabelsProp = async (labelsToAssign) => {
    setLoading(true);

    const toArray = (value) => (Array?.isArray(value) ? value : [value]);
    const res = await dispatch(
      addNewLabelOwner({
        record_ids: toArray(ownerDetailData?.id),
        labels: labelsToAssign,
      }),
    );

    if (addNewLabelOwner.fulfilled.match(res)) {
      getOwnerDetaildata();
      toast.dismiss();

      CommonToast({
        text: "Labels assigned successfully.",
        icon: "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg",
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }

    if (addNewLabelOwner.rejected.match(res)) {
      toast.dismiss();
      CommonToast({
        text: res.payload,
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }
    setLoading(false);
    if (addNewLabelOwner?.fulfilled?.match(res)) {
      return true;
    } else {
      return false;
    }
  };

  const handleUnassignLabelsProp = async (labelsToUnassign) => {
    setLoading(true);

    const toArray = (value) => (Array.isArray(value) ? value : [value]);

    const res = await dispatch(
      removeNewLabelOwner({
        record_ids: toArray(ownerDetailData?.id),
        labels: labelsToUnassign,
      }),
    );

    if (removeNewLabelOwner.fulfilled.match(res)) {
      getOwnerDetaildata();
      toast.dismiss();

      CommonToast({
        text: "Labels unassigned successfully.",
        icon: "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg",
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }

    if (removeNewLabelOwner.rejected.match(res)) {
      toast.dismiss();
      CommonToast({
        text: res.payload,
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }
    setLoading(false);
    if (removeNewLabelOwner?.fulfilled?.match(res)) {
      return true;
    } else {
      return false;
    }
  };

  const yellowStar =
    "https://q2pay.in/new_assets/common/detail_page/favourite_filled.svg";
  const whiteStar =
    "https://q2pay.in/new_assets/common/detail_page/favourite.svg";
  const internalTransaction =
    "https://q2pay.in/new_assets/common/detail_page/initiate_internal_transaction.svg";
  const LinkedLogo =
    "https://q2pay.in/new_assets/common/detail_page/linked_white_circle.svg";
  const assigntag =
    "https://q2pay.in/new_assets/common/detail_page/assign_tag.svg";
  const labelWhite =
    "https://q2pay.in/new_assets/common/detail_page/label_with_white_circle.svg";

  const transactionHistory =
    "https://q2pay.in/new_assets/common/detail_page/transaction_history.svg";

  const view_statement =
    "https://q2pay.in/new_assets/common/detail_page/view_statement.svg";

  const live_statement =
    "https://q2pay.in/new_assets/common/detail_page/live_statement.svg";

  const RefreshIcon =
    "https://q2pay.in/new_assets/common/view_all/reload_refresh_white.svg";

  return (
    <>
      <div
        className={`${
          props?.popType == "reimburseowner_details" ||
          props?.popType == "ownerStatement"
            ? "h-full"
            : "h-full-height"
        }`}
        style={{
          backgroundColor: "var(--primary-bg)",
          overflowX: "hidden",
          overflowY:
            viewStatementOpenPop || selectedTagOpenPop ? "hidden" : "auto",
        }}
      >
        <div>
          {viewStatementOpenPop && (
            <div
              style={{ zIndex: "var(--max-zindex)" }}
              className="fixed top-left-base left-left-base w-width-full h-height-full bg-custom-backdrop bg-opacity-dark-opacity"
            >
              <div
                className={`animate-none ${animateStatement ? "Qsmd:animate-slideInFromLeft" : "Qsmd:animate-slideInFromRight"} w-width-full h-height-full fixed top-left-base`}
              >
                <div
                  style={{ backgroundColor: "var(--primary-card)" }}
                  className="common_popup relative flex flex-col"
                >
                  <div className="top-left-base bg-primary-card z-z-index-header hidden Qsmd:flex p-padding-md left-left-base justify-between items-center w-width-full">
                    <p className="popup-header">View bank statement</p>
                    <IconRoundButton
                      enabledBgColor="var(--primary-nav)"
                      isLoading={false}
                      handleFunction={() => {
                        setAnimateStatement(true);
                        setTimeout(() => {
                          setViewstatementOpenPop(false);
                          setAnimateStatement(false);
                        }, IntervalConfiguration.intervalSmall);
                      }}
                      hoverOption="white"
                      icon={
                        "https://q2pay.in/new_assets/common/create_flow/close.svg"
                      }
                      title="Close"
                      isDisabled={false}
                    />
                  </div>
                  <OwnerAllStatement
                    popType={"ownerStatement"}
                    ownerDetailId={id}
                    ownerDetailData={ownerDetailData}
                    setViewstatementOpenPop={setViewstatementOpenPop}
                  />
                </div>
              </div>
            </div>
          )}
          {viewItemisedOpenPop && (
            <div
              style={{ zIndex: "var(--max-zindex)" }}
              className="fixed top-left-base left-left-base w-width-full h-height-full bg-custom-backdrop bg-opacity-dark-opacity"
            >
              <div
                className={`animate-none ${animateItemised ? "Qsmd:animate-slideInFromLeft" : "Qsmd:animate-slideInFromRight"} w-width-full h-height-full fixed top-left-base`}
              >
                <div
                  style={{ backgroundColor: "var(--primary-card)" }}
                  className="common_popup relative flex flex-col"
                >
                  <div className="top-left-base bg-primary-bg z-z-index-header hidden Qsmd:flex p-padding-md left-left-base justify-between items-center w-width-full">
                    <p className="popup-header">View live statement</p>
                    <IconRoundButton
                      enabledBgColor="var(--primary-nav)"
                      isLoading={false}
                      handleFunction={() => {
                        setAnimateItemised(true);
                        setTimeout(() => {
                          setViewItemisedOpenPop(false);
                          setAnimateItemised(false);
                        }, IntervalConfiguration.intervalSmall);
                      }}
                      hoverOption="white"
                      icon={
                        "https://q2pay.in/new_assets/common/create_flow/close.svg"
                      }
                      title="Close"
                      isDisabled={false}
                    />
                  </div>
                  <ItemisedReportComponent
                    popType={"ownerStatement"}
                    ownerDetailId={id}
                    ownerDetailData={ownerDetailData}
                    setViewItemisedOpenPop={setViewItemisedOpenPop}
                  />
                </div>
              </div>
            </div>
          )}
          {showLabelsPopup && (
            <div
              onClick={(e) => {
                e.stopPropagation();
                setShowLabelsPopup(true);
              }}
              className="fixed top-left-base w-width-full h-height-full bg-PopUp-BackDrop bg-opacity-dark-opacity flex items-center justify-center z-z-index-max"
            >
              <CommonAssignLabelPopup
                headerTitle="Assign/unassign labels:"
                headersubtext="Labels will be used to generate statistics for the associated accounts."
                closehandleFunction={handleClose}
                closeisDisabled={false}
                labels={labels}
                setLabels={setLabels}
                LabelAccounts={ownerDetailData?.id}
                isLabelPopupOpen={showLabelsPopup}
                filteredData={ownerAccDetailData?.owner_accounts}
                labelActionDispatchedRef={labelActionDispatchedRef}
                onClose={handleClose}
                loading={loading}
                setLoading={setLoading}
                handleAssignLabels={handleAssignLabelsProp}
                handleUnassignLabels={handleUnassignLabelsProp}
                type="details"
              />
            </div>
          )}
          {openHistory && (
            <div className="fixed top-left-base left-left-base w-screen h-screen z-z-index-max bg-PopUp-BackDrop bg-opacity-dark-opacity">
              <LargePopupRedirect
                headerTitle="Internal transaction history "
                headersubtext="All transactions related to the owner account are listed below."
                closeiconenabledBgColor="var(--primary-nav)"
                closeiconisLoading={false}
                closeiconhandleFunction={() => setOpenHistory(false)}
                closeicon={
                  "https://q2pay.in/new_assets/common/create_flow/close.svg"
                }
                closeiconhoverOption="white"
                closeiconbtnType={"button"}
                closeiconisDisabled={false}
                closeicondisabledBgColor={""}
                closeiconbuttonRef={null}
                closeicontitle={"Close"}
                btnType={"button"}
                confirmbtnrequired={true}
                enabledBgColor={"var(--negative-act)"}
                hoverOption={"dark"}
                enabledTextColor={"var(--text-primary)"}
                fullWidthRequired={false}
                isDisabled={false}
                isCreditDebitRequired={true}
                togglepan={() => {
                  setBalanceType("credit");
                }}
                toggleBank={() => {
                  setBalanceType("debit");
                }}
              >
                <InternalTransactionViewAll
                  onClose={() => setOpenHistory(false)}
                  txnHistorytype={"ownerDetailTxnHistory"}
                  owner_account_id={ownerDetailData?.id}
                  owner_account_bank_acc_no={ownerDetailData?.bank_acc_no}
                  OwnerDetail={true}
                  BeneAccId={beneViewAllAccData?.internal_accounts?.[0]?.id}
                  balanceType={balanceType}
                  setBalanceType={setBalanceType}
                />
              </LargePopupRedirect>
            </div>
          )}
          {openBeneHistory && (
            <div className="fixed top-left-base left-left-base w-screen h-screen z-z-index-max bg-PopUp-BackDrop bg-opacity-dark-opacity">
              <LargePopupRedirect
                headerTitle="Beneficiary transaction history"
                headersubtext="All transactions related to the owner account are listed below."
                closeiconenabledBgColor="var(--primary-nav)"
                closeiconisLoading={false}
                closeiconhandleFunction={() => setOpenBeneHistory(false)}
                closeicon={
                  "https://q2pay.in/new_assets/common/create_flow/close.svg"
                }
                closeiconhoverOption="white"
                closeiconbtnType={"button"}
                closeiconisDisabled={false}
                closeicondisabledBgColor={""}
                closeiconbuttonRef={null}
                closeicontitle={"Close"}
                btnType={"button"}
                confirmbtnrequired={true}
                enabledBgColor={"var(--negative-act)"}
                hoverOption={"dark"}
                enabledTextColor={"var(--text-primary)"}
                fullWidthRequired={false}
                isDisabled={false}
              >
                <BeneficiaryTransactionViewall
                  onClose={() => setOpenBeneHistory(false)}
                  typepop={"txnHistorypopup"}
                  Owner_account_id={ownerDetailData?.id}
                  Owner_account_number={ownerDetailData?.bank_acc_no}
                  OwnerDetail={true}
                />
              </LargePopupRedirect>
            </div>
          )}
          {minBalance && (
            <div className="fixed w-width-full h-height-full flex items-center bg-Primary-black justify-center z-z-index-max bg-opacity-dark-opacity">
              <MinimumBal
                setMinBalance={setMinBalance}
                amount={amount}
                setAmount={setAmount}
              />
            </div>
          )}
          {selectedTagOpenPop && (
            <div
              className="fixed top-left-base w-width-full h-height-full bg-PopUp-BackDrop bg-opacity-dark-opacity flex items-center justify-center z-z-index-max"
              onClick={handleCloseModal}
            >
              {
                <CommonAssignTagPopup
                  headerTitle="Assign/Unassign tags:"
                  closehandleFunction={handleCloseModal}
                  closedisabledBgColor=""
                  closebuttonRef=""
                  closeimgColor=""
                  loading={loading}
                  newTags={newTags}
                  handleAddTags={handleAddTags}
                  existingTags={existingTags}
                  setExistingTags={setExistingTags}
                  handleRemoveTags={handleRemoveTags}
                  setNewTags={setNewTags}
                  ownerExistingTag={ownerDetailData?.tags}
                  AllTags={AllTags}
                  setAllTags={setAllTags}
                  setLoading={setLoading}
                  id={id}
                  ownerDetailData={ownerDetailData}
                  type={"ownerDetails"}
                />
              }
            </div>
          )}
          {showGstPopup && (
            <LargePopupRedirect
              headerTitle="GST Details"
              isfullViewrequired={true}
              fullviewhandleFunction={() =>
                navigate(`/settings/GST_verification`, {
                  state: ownerDetailData?.gstin_detail,
                })
              }
              closeiconhandleFunction={() => setGstShowPopup(false)}
            >
              <GSTVerification
                gst_number={ownerDetailData?.gstin_detail}
                popup={true}
              />
            </LargePopupRedirect>
          )}
          {showIfscPopup && (
            <div>
              <LargePopupRedirect
                headerTitle="IFSC Details"
                isfullViewrequired={true}
                fullviewhandleFunction={() =>
                  navigate(
                    `/settings/IFSC_verification/IFSC_Details/${ownerDetailData?.ifsc_code}`,
                  )
                }
                closeiconhandleFunction={() => setIfscShowPopup(false)}
              >
                <OwnerAccountIFSC
                  ifsc_code={ownerDetailData?.ifsc_code}
                  popup={true}
                />
              </LargePopupRedirect>
            </div>
          )}
          {showPanPopup && (
            <div>
              <LargePopupRedirect
                headerTitle="PAN Details"
                isfullViewrequired={true}
                fullviewhandleFunction={() =>
                  navigate(`/settings/PAN_verification`, {
                    state: ownerDetailData?.pan_no,
                  })
                }
                closeiconhandleFunction={() => setPanShowPopup(false)}
              >
                <PanVerification
                  pan_no={ownerDetailData?.pan_no}
                  popup={true}
                />
              </LargePopupRedirect>
            </div>
          )}
          {showFavPopup && (
            <div className="fixed top-left-base left-left-base w-screen h-screen z-z-index-max bg-PopUp-BackDrop bg-opacity-dark-opacity">
              <SmallPopupWithBulletPoint
                headerTitle={
                  isFavTagExist ? "Remove from favourite" : "Set to favourite"
                }
                headerFontWeight="semibold"
                headerFontColor="text-primary"
                textSize="font-md"
                secondHeaderTitle={
                  isFavTagExist
                    ? "Are you sure you want to remove this account from favourites?"
                    : "Are you sure you want to set this account to favourites?"
                }
                secondHeaderFontWeight="semibold"
                bulletPoints={
                  isFavTagExist
                    ? [
                        "It will no longer appear in the favourite section on dashboard.",
                        "Account will no longer be prioritized for statistics.",
                      ]
                    : [
                        "It will appear in the favourite section on dashboard",
                        "Account will be prioritize for statistics.",
                      ]
                }
                isTextInputField={false}
                btnOneText="Cancel"
                btnOneHandleFunction={() => setFavShowPopup(false)}
                btnOneOutLineColor="var(--text-primary)"
                btnOneIsDisabled={isFavLoading ? true : false}
                btnOneEnabledTextColor="var(--text-primary)"
                btnOneHoverOption="white"
                btnTwoText={isFavTagExist ? "Remove" : "Set"}
                btnTwoHandleFunction={handleFavourite}
                btnTwoEnabledBgColor="var(--positive-act)"
                btnTwoEnabledTextColor="var(--text-primary)"
                btnTwoIsLoaderNeeded={true}
                btnTwoIsLoading={isFavLoading}
                btnTwoHoverOption="black"
              />
            </div>
          )}
          {showCreditLimitPopup && (
            <div className="fixed top-left-base left-left-base w-screen h-screen z-z-index-max bg-PopUp-BackDrop bg-opacity-dark-opacity">
              <SmallPopupWithInput
                headerTitle={"Set credit limit"}
                headerFontWeight="semibold"
                headerFontColor="text-primary"
                textSize="font-md"
                secondHeaderTitle={
                  "Specify the credit limit to be applied to this account."
                }
                secondHeaderFontWeight="normal"
                secondHeaderTextSize="font-xs"
                isTextInputField={true}
                inputPlaceholder="Amount"
                inputVariant="default"
                inputBgColor="var(--primary-bg)"
                inputFgColor="var(--text-secondary)"
                inputOnInput={(value) => setCreditLimitInput(value)}
                inputValue={creditLimitInput}
                inputFontKind="medium"
                inputIsFullWidth={true}
                btnOneText="Cancel"
                btnOneHandleFunction={() => setShowCreditLimitPopup(false)}
                btnOneOutLineColor="var(--text-primary)"
                btnOneIsDisabled={isCreditLimitLoading}
                btnOneEnabledTextColor="var(--text-primary)"
                btnOneHoverOption="white"
                btnTwoText="Confirm"
                btnTwoHandleFunction={handleCreditLimit}
                btnTwoEnabledBgColor="var(--positive-act)"
                btnTwoDisabledBgColor="var(--text-disabled)"
                btnTwoEnabledTextColor="var(--text-primary)"
                btnTwoIsDisabled={
                  !creditLimitInput.length ||
                  creditLimitInput === initialCreditLimit
                }
                btnTwoIsLoaderNeeded={true}
                btnTwoIsLoading={isCreditLimitLoading}
                btnTwoHoverOption="black"
                inputType="amount"
                btnOneBtnType="button"
                btnTwoBtnType="button"
                btnTwoInActiveVariantNeeded={true}
              />
            </div>
          )}
          {showMinimumLimitPopup && (
            <div className="fixed top-left-base left-left-base w-screen h-screen z-z-index-max bg-PopUp-BackDrop bg-opacity-dark-opacity">
              <SmallPopupWithInput
                headerTitle={"Set minimum limit"}
                headerFontWeight="semibold"
                headerFontColor="text-primary"
                textSize="font-md"
                noteText="The minimum balance cannot exceed the auto-sweep limit."
                secondHeaderTitle={
                  "The required minimum balance to be maintained in this account and cannot be utilized for any transactions."
                }
                secondHeaderFontWeight="normal"
                secondHeaderTextSize="font-xs"
                isTextInputField={true}
                inputPlaceholder="Amount"
                inputVariant="default"
                inputBgColor="var(--primary-bg)"
                inputFgColor="var(--text-secondary)"
                inputOnInput={(value) => setMinimumLimitInput(value)}
                inputValue={minimumLimitInput}
                inputFontKind="medium"
                inputIsFullWidth={true}
                btnOneText="Cancel"
                btnOneHandleFunction={() => setShowMinimumLimitPopup(false)}
                btnOneOutLineColor="var(--text-primary)"
                btnOneIsDisabled={isMinimumLimitLoading}
                btnOneEnabledTextColor="var(--text-primary)"
                btnOneHoverOption="white"
                btnTwoText="Confirm"
                btnTwoHandleFunction={handleMinimumLimit}
                btnTwoEnabledBgColor="var(--positive-act)"
                btnTwoDisabledBgColor="var(--text-disabled)"
                btnTwoEnabledTextColor="var(--text-primary)"
                btnTwoIsDisabled={
                  !minimumLimitInput.length ||
                  minimumLimitInput === initialMinimumLimit ||
                  Number(minimumLimitInput) > Number(maximumLimitInput)
                }
                btnTwoIsLoaderNeeded={true}
                btnTwoIsLoading={isMinimumLimitLoading}
                btnTwoHoverOption="black"
                inputType="amount"
                btnOneBtnType="button"
                btnTwoBtnType="button"
                btnTwoInActiveVariantNeeded={true}
              />
            </div>
          )}
          {showMaximumLimitPopup && (
            <div className="fixed top-left-base left-left-base w-screen h-screen z-z-index-max bg-PopUp-BackDrop bg-opacity-dark-opacity">
              <SmallPopupWithInput
                headerTitle="Set auto sweep limit"
                headerFontWeight="semibold"
                headerFontColor="text-primary"
                textSize="font-md"
                noteText="The auto-sweep limit cannot be lower than the minimum balance."
                secondHeaderTitle={
                  "Enter the maximum balance limit for this account; balances exceeding this amount will be auto-swept to a another account."
                }
                secondHeaderFontWeight="normal"
                secondHeaderTextSize="font-xs"
                isTextInputField={true}
                inputPlaceholder="Amount"
                inputVariant="default"
                inputBgColor="var(--primary-bg)"
                inputFgColor="var(--text-secondary)"
                inputOnInput={(value) => setMaximumLimitInput(value)}
                inputValue={maximumLimitInput}
                inputFontKind="medium"
                inputIsFullWidth={true}
                btnOneText="Cancel"
                btnOneHandleFunction={() => setShowMaximumLimitPopup(false)}
                btnOneOutLineColor="var(--text-primary)"
                btnOneIsDisabled={isMaximumLimitLoading}
                btnOneEnabledTextColor="var(--text-primary)"
                btnOneHoverOption="white"
                btnTwoText="Confirm"
                btnTwoHandleFunction={handleMaximumLimit}
                btnTwoEnabledBgColor="var(--positive-act)"
                btnTwoDisabledBgColor="var(--text-disabled)"
                btnTwoEnabledTextColor="var(--text-primary)"
                btnTwoIsDisabled={
                  !maximumLimitInput.length ||
                  maximumLimitInput === initialMaximumLimit ||
                  Number(maximumLimitInput) < Number(minimumLimitInput)
                }
                btnTwoIsLoaderNeeded={true}
                btnTwoIsLoading={isMaximumLimitLoading}
                btnTwoHoverOption="black"
                inputType="amount"
                btnOneBtnType="button"
                btnTwoBtnType="button"
                btnTwoInActiveVariantNeeded={true}
              />
            </div>
          )}
          {accountTypePopup && (
            <div className="fixed top-left-base left-left-base w-screen h-screen z-z-index-max bg-PopUp-BackDrop bg-opacity-dark-opacity">
              <EditCommonPopup
                btnOneHandleFunction={() => {
                  if (!accountTypeLoading) setShowAccountTypePopup(false);
                }}
                headerTitle="Select account type"
                headerFontWeight="semibold"
                headerFontColor="text-primary"
                textSize="font-md"
                chipsArray={chipsArray}
                btnOneText="Cancel"
                btnOneEnabledBgColor="var(--primary-bg)"
                btnOneEnabledTextColor="var(--text-primary)"
                btnOneHoverOption="white"
                btnOneIsDisabled={accountTypeLoading}
                btnOneOutLineColor="var(--text-primary)"
                btnTwoText="Confirm"
                btnTwoHandleFunction={handleAccountType}
                btnTwoIsDisabled={selectedChipIndex === ""}
                btnTwoEnabledBgColor="var(--positive-act)"
                btnTwoEnabledTextColor="var(--text-primary)"
                btnTwoIsLoaderNeeded={true}
                btnTwoIsLoading={accountTypeLoading}
                btnTwoDisabledBgColor="var(--text-disabled)"
                btnTwoHoverOption="black"
                btnOneBtnType="button"
                btnTwoBtnType="button"
                btnOneInActiveVariantNeeded={true}
                btnTwoInActiveVariantNeeded={true}
              />
            </div>
          )}
          {infoAmountPopup && (
            <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
              <CommonInfoBox
                rows={[
                  {
                    label: "Balance",
                    value: ownerDetailData?.owner_account_balance,
                    icon: "https://q2pay.in/new_assets/common/settings/plus_white.svg",
                  },
                  {
                    label: "Credit limit",
                    value: ownerDetailData?.od_limit || 0,
                    operation: "add",
                  },
                ]}
                headerTitle={"Amount Breakdown"}
                headerFontColor={"text-primary"}
                textSize={"font-md"}
                popupBgColor={"primary-bg"}
                transactionLabel={"Available balance"}
                finalAmountLabel={"Available balance"}
                transactionAmount={ownerDetailData?.owner_account_balance}
                onClosepop={() => setInfoAmountPopup(false)}
              />
            </div>
          )}
        </div>
        <div
          className="w-width-full flex Qsmd:hidden fixed z-z-index-fixed-ui items-center bg-primary-nav-act justify-between"
          style={{
            display:
              props?.popType == "ownerStatement" ||
              props?.popType == "reimburseowner_details" ||
              openHistory
                ? "none"
                : "",
          }}
        >
          <TopNavComponent
            isFormattingNotRequired={true}
            topNavHeader={"Owner"}
            topNavSubText="Account details"
          />
        </div>

        {loading || !ownerDetailData ? (
          <div className="owner-loader-container justify-center items-center flex h-full-height">
            <Loader />
          </div>
        ) : (
          <>
            <div
              style={{
                marginTop:
                  props?.popType == "ownerStatement" ||
                  props?.popType == "reimburseowner_details"
                    ? "var(--margin-base)"
                    : "var(--navbar-height)",
                paddingTop: "var(--padding-base)",
              }}
              className={` ${props?.popType == "reimburseowner_details" ? " w-full" : "content-page"}  relative`}
            >
              <div className="ownerDetail-container ">
                <div className="acc-section">
                  <div
                    className={`${props?.popType == "reimburseowner_details" ? " w-full mx-margin-base Qsmd:mx-margin-sm" : props.popType !== "ownerStatement" ? "major-div mx-margin-base Qsmd:mx-margin-sm" : "w-width-full  mt-margin-base "}`}
                  >
                    <div
                      className={`individual-bank-detail ${props?.popType == "reimburseowner_details" ? "" : "pt-padding-base"}  Qsmd:pt-padding-base mt-margin-base Qsmd:mt-[var(--borderthickness)] px-padding-md Qsmd:px-padding-base w-auto Qlg:w-width-full `}
                    >
                      <div
                        className={`${props.popType !== "ownerStatement" ? "individual-account  Qlg:pt-padding-sm justify-center  mt-margin-base" : "individual-account mt-margin-base"}`}
                      >
                        {ownerDetailData?.owner_account_balance ? (
                          <div className="acc-balance-content">
                            <div
                              className="refresh-amt-div text-font-md relative"
                              style={{
                                fontWeight: "var(--font-semibold)",
                                color:
                                  ownerDetailData?.owner_account_balance !==
                                    null &&
                                  ownerDetailData?.owner_account_balance !==
                                    undefined &&
                                  (ownerDetailData?.owner_account_balance ===
                                    "xxxx.xx" ||
                                    Number.isNaN(
                                      Number(
                                        ownerDetailData?.owner_account_balance,
                                      ),
                                    ) ||
                                    Number(
                                      ownerDetailData?.owner_account_balance,
                                    ) >= GlobalConfiguration?.lengthCheckZero)
                                    ? "var(--settled)"
                                    : "var(--failed)",
                                paddingRight: "var(--padding-md)",
                              }}
                            >
                              {shouldBeRedacted(
                                ownerDetailData?.owner_account_balance,
                              )
                                ? ""
                                : "INR "}
                              {
                                formatTotalBalance(
                                  Number(
                                    ownerDetailData?.owner_account_balance,
                                  ) + Number(ownerDetailData?.od_limit || 0),
                                ).amount
                              }
                              <div
                                style={{
                                  display:
                                    services?.includes("VAccountBalance") ||
                                    services?.includes("Admin")
                                      ? "flex"
                                      : "none",
                                }}
                                className="absolute bottom-[var(--padding-button-l)] right-top_xxs "
                              >
                                <img
                                  src={
                                    "https://q2pay.in/new_assets/common/detail_page/info.svg"
                                  }
                                  className="w-icon-sm h-icon-sm cursor-pointer"
                                  onClick={() => setInfoAmountPopup(true)}
                                />
                              </div>
                            </div>
                            {ownerDetailData?.connected_banking === "Y" &&
                            !ownerAccBalanceLoading ? (
                              Number(currentConnectedBal) >
                              Number(prevConnectedBal) ? (
                                <span className="mx-top_xs">
                                  <img
                                    className="h-icon-md w-icon-md"
                                    src={
                                      "https://q2pay.in/new_assets/gifs/arrow_up_green_gif.gif"
                                    }
                                    alt=""
                                  />
                                </span>
                              ) : Number(currentConnectedBal) <
                                Number(prevConnectedBal) ? (
                                <span className="mx-top_xs">
                                  <img
                                    className="h-icon-md w-icon-md"
                                    src={
                                      "https://q2pay.in/new_assets/gifs/arrow_down_red_gif.gif"
                                    }
                                    alt=""
                                  />
                                </span>
                              ) : undefined
                            ) : undefined}
                            {ownerDetailData?.connected_banking === "Y" && (
                              <div className="border-l h-[-webkit-fill-available] border-primary-bg"></div>
                            )}

                            {ownerDetailData?.connected_banking === "Y" && (
                              <div className="refresh-div">
                                {ownerAccBalanceLoading &&
                                !ownerAccBalanceError &&
                                accId === ownerDetailData?.id ? (
                                  <BalanceLoader
                                    ownerDetails="BalanceownerDetails"
                                    loader={ownerAccBalanceLoading}
                                  />
                                ) : !ownerAccBalanceLoading &&
                                  accId === ownerDetailData?.id ? (
                                  <BalanceLoader
                                    loader={ownerAccBalanceLoading}
                                    setAccId={setAccId}
                                    ownerDetails="BalanceownerDetails"
                                  />
                                ) : (
                                  <CardActionableButton
                                    btnType="button"
                                    handleFunction={(e) => {
                                      if (
                                        services?.includes("VAccountBalance") ||
                                        services?.includes("Admin")
                                      ) {
                                        if (
                                          ownerDetailData?.connected_banking ===
                                          "Y"
                                        ) {
                                          setAccId(ownerDetailData?.id);
                                          handleRefresh(ownerDetailData?.id);
                                        }
                                      } else {
                                        navigate("/feature_not_assigned", {
                                          state: {
                                            unavailableService: [
                                              "VAccountBalance",
                                              "Admin",
                                            ],
                                          },
                                        });
                                      }
                                    }}
                                    isDisabled={
                                      ensureAll(["VAccountBalance"]).status ||
                                      ensureAll(["Admin"]).status
                                        ? false
                                        : true
                                    }
                                    disabledBgColor="var(--primary-nav-act)"
                                    icon="https://q2pay.in/new_assets/common/view_all/reload_refresh_white.svg"
                                    hoverOption="white"
                                    title="Refresh"
                                  />
                                )}
                              </div>
                            )}
                          </div>
                        ) : (
                          <div className="acc-balance-content">
                            <div>N/A</div>
                          </div>
                        )}
                        <div className="acc-number-balance w-auto">
                          Available balance
                        </div>
                      </div>
                      <div className="hidden Qsmd:flex border-primary-bg border-l-border my-margin-md h-auto"></div>
                      <div className="w-width-full Qsmd:w-tl-width-2  flex justify-between border-t-border border-t-primary-bg Qlg:border-b-border-base border-b-border border-b-primary-bg  Qsmd:border-none Qsmd:h-auto Qlg:pl-padding-md Qsmd:pl-padding-base">
                        <div className="owner-details-acc-balance  Qsmd:mr-margin-md Qsmd:pl-padding-md Qlg:pl-padding-base">
                          {ownerDetailData?.owner_account_balance ? (
                            <div className="acc-balance-content">
                              <div
                                className=" refresh-amt-div text-font-md"
                                style={{
                                  fontWeight: "var(--font-semibold)",
                                  color:
                                    ownerDetailData?.owner_account_balance !==
                                      null &&
                                    ownerDetailData?.owner_account_balance !==
                                      undefined &&
                                    (ownerDetailData?.owner_account_balance ===
                                      "xxxx.xx" ||
                                      Number.isNaN(
                                        Number(
                                          ownerDetailData?.owner_account_balance,
                                        ),
                                      ) ||
                                      Number(
                                        ownerDetailData?.owner_account_balance,
                                      ) >= GlobalConfiguration?.lengthCheckZero)
                                      ? "var(--settled)"
                                      : "var(--failed)",
                                  paddingRight: "var(--padding-sm)",
                                  borderRight:
                                    ownerDetailData?.connected_banking ===
                                      "Y" &&
                                    "var(--border) solid var(--primary-bg)",
                                }}
                              >
                                {shouldBeRedacted(
                                  ownerDetailData?.owner_account_balance,
                                )
                                  ? ""
                                  : "INR "}
                                {
                                  formatTotalBalance(
                                    Number(
                                      ownerDetailData?.owner_account_balance,
                                    ),
                                  ).amount
                                }
                                <span className="ml-top_xs">
                                  {ownerDetailData?.connected_banking === "Y" &&
                                  !ownerAccBalanceLoading ? (
                                    Number(currentConnectedBal) >
                                    Number(prevConnectedBal) ? (
                                      <img
                                        className="h-icon-md w-icon-md"
                                        src={
                                          "https://q2pay.in/new_assets/gifs/arrow_up_green_gif.gif"
                                        }
                                        alt=""
                                      />
                                    ) : Number(currentConnectedBal) <
                                      Number(prevConnectedBal) ? (
                                      <img
                                        className="h-icon-md w-icon-md"
                                        src={
                                          "https://q2pay.in/new_assets/gifs/arrow_down_red_gif.gif"
                                        }
                                        alt=""
                                      />
                                    ) : undefined
                                  ) : undefined}
                                </span>
                              </div>
                              {ownerDetailData?.connected_banking === "Y" && (
                                <div className="refresh-div">
                                  {ownerAccBalanceLoading &&
                                  !ownerAccBalanceError &&
                                  accId === ownerDetailData?.id ? (
                                    <BalanceLoader
                                      ownerDetails="BalanceownerDetails"
                                      loader={ownerAccBalanceLoading}
                                    />
                                  ) : !ownerAccBalanceLoading &&
                                    accId === ownerDetailData?.id ? (
                                    <BalanceLoader
                                      loader={ownerAccBalanceLoading}
                                      setAccId={setAccId}
                                      ownerDetails="BalanceownerDetails"
                                    />
                                  ) : (
                                    <CardActionableButton
                                      btnType="button"
                                      handleFunction={(e) => {
                                        if (
                                          services?.includes(
                                            "VAccountBalance",
                                          ) ||
                                          services?.includes("Admin")
                                        ) {
                                          if (
                                            ownerDetailData?.connected_banking ===
                                            "Y"
                                          ) {
                                            setAccId(ownerDetailData?.id);
                                            handleRefresh(ownerDetailData?.id);
                                          }
                                        } else {
                                          navigate("/feature_not_assigned", {
                                            state: {
                                              unavailableService: [
                                                "VAccountBalance",
                                                "Admin",
                                              ],
                                            },
                                          });
                                        }
                                      }}
                                      isDisabled={
                                        ensureAll(["VAccountBalance"]).status ||
                                        ensureAll(["Admin"]).status
                                          ? false
                                          : true
                                      }
                                      disabledBgColor="var(--primary-nav-act)"
                                      icon="https://q2pay.in/new_assets/common/view_all/reload_refresh_white.svg"
                                      hoverOption="white"
                                      title="Refresh"
                                    />
                                  )}
                                </div>
                              )}
                            </div>
                          ) : (
                            <div className="acc-balance-content">
                              <div>N/A</div>
                            </div>
                          )}
                          <div className="acc-number-balance w-auto">
                            {ownerDetailData?.owner_account_balance ? (
                              formatTotalBalance(
                                Number(ownerDetailData?.owner_account_balance),
                              ).prefix == "crores" ? (
                                <p>
                                  Balance - In crores{" "}
                                  {(ownerDetailData?.connected_banking ===
                                    "Y" ||
                                    "N") &&
                                  ownerDetailData?.active_status !== "Y"
                                    ? `- updated  ${ownerDetailData?.owner_account_balance_last_fetched_at_in_words}`
                                    : null}
                                </p>
                              ) : (
                                <p>
                                  Balance - updated{" "}
                                  {
                                    ownerDetailData?.owner_account_balance_last_fetched_at_in_words
                                  }
                                </p>
                              )
                            ) : (
                              <>
                                <p>Balance </p>
                              </>
                            )}
                          </div>
                        </div>

                        <div className="statement-view-acc flex-row hidden Qsmd:flex bg-primary-nav-act">
                          <div className=""></div>
                          <TopNavSmallButton
                            btnText={
                              <>
                                {" "}
                                Bank <br /> statement
                              </>
                            }
                            btnType="button"
                            imgColor="var(--text-primary)"
                            icon={view_statement}
                            enabledTextColor="var(--text-primary)"
                            enabledBgColor="var(--primary-nav-act)"
                            hoverOption="white"
                            fullWidthRequired={false}
                            isLoading={false}
                            isDisabled={
                              props?.popType === "ownerStatement" ||
                              props?.popType == "reimburseowner_details" ||
                              (!services?.includes("VAccountBalance") &&
                                !services?.includes("Admin")) ||
                              ownerDetailData?.connected_banking !== "Y"
                            }
                            handleFunction={() => {
                              if (
                                props?.popType === "ownerStatement" ||
                                props?.popType == "reimburseowner_details"
                              ) {
                                CommonToast({
                                  text: "Action restricted in popup mode.",
                                  icon: ICONS?.ERROR_WHITE_CIRCLE,
                                  variant: "var(--error)",
                                });
                              } else if (
                                props?.popType !== "ownerStatement" &&
                                (services?.includes("VAccountBalance") ||
                                  services?.includes("Admin")) &&
                                ownerDetailData?.connected_banking === "Y"
                              ) {
                                handleViewStatement();
                              } else if (
                                !services?.includes("VAccountBalance") &&
                                !services?.includes("Admin")
                              ) {
                                navigate("/feature_not_assigned", {
                                  state: {
                                    unavailableService: "VAccountBalance,Admin",
                                  },
                                });
                              }
                            }}
                          />
                          <div className="ownerdetail-border-div hidden Qsmd:block"></div>
                          <TopNavSmallButton
                            enabledBgColor={"var(--primary-nav-act)"}
                            enabledTextColor={"var(--text-primary)"}
                            hoverOption="white"
                            isDisabled={
                              props?.popType === "ownerStatement" ||
                              props?.popType == "reimburseowner_details" ||
                              (!services?.includes("VItemisedStatement") &&
                                !services?.includes("Admin")) ||
                              ownerDetailData?.connected_banking !== "Y"
                            }
                            handleFunction={() => {
                              if (
                                props?.popType == "ownerStatement" ||
                                props?.popType == "reimburseowner_details"
                              ) {
                                CommonToast({
                                  text: "Action restricted in popup mode.",
                                  icon: ICONS?.ERROR_WHITE_CIRCLE,
                                  variant: "var(--error)",
                                });
                              } else {
                                if (
                                  (services?.includes("VItemisedStatement") ||
                                    services?.includes("Admin")) &&
                                  ownerDetailData?.connected_banking === "Y"
                                ) {
                                  setViewItemisedOpenPop(true);
                                } else if (
                                  !services?.includes("VItemisedStatement") &&
                                  !services?.includes("Admin")
                                ) {
                                  navigate("/feature_not_assigned", {
                                    state: {
                                      unavailableService: "VItemisedStatement ",
                                    },
                                  });
                                }
                              }
                            }}
                            icon={live_statement}
                            btnText={
                              <>
                                {" "}
                                Live <br />
                                statement
                              </>
                            }
                          />
                        </div>
                      </div>
                    </div>

                    <div className="acc-status-main Qsmd:flex  w-width-full px-padding-md Qsmd:px-padding-base">
                      <div className="flex flex-1">
                        <div className="individual-account !pt-padding-md Qsmd:pt-padding-lg justify-center mt-margin-base">
                          <div className="flex gap-gap-sm items-center">
                            {ownerDetailData?.account_type ===
                              "Overdraft Account" &&
                            ownerDetailData?.od_limit ? (
                              <>
                                <div
                                  className={`text-font-md font-normal text-text-primary`}
                                >
                                  INR{" "}
                                  {FormatAmount({
                                    price: ownerDetailData?.od_limit,
                                  })}
                                </div>
                                <div
                                  className="cursor-pointer"
                                  onClick={() => {
                                    setCreditLimitInput(
                                      ownerDetailData?.od_limit ||
                                        GlobalConfiguration?.lengthCheckZero,
                                    );
                                    setShowCreditLimitPopup(true);
                                  }}
                                  disabled={!services?.includes("UAccount")}
                                >
                                  <img
                                    src={
                                      "https://q2pay.in/new_assets/common/create_flow/edit.svg"
                                    }
                                    className="w-icon-sm h-icon-sm"
                                    alt={"edit"}
                                  />
                                </div>
                              </>
                            ) : (
                              <div className="acc-balance-content">
                                <div>N/A</div>
                              </div>
                            )}
                          </div>
                          <div className="acc-number-balance">Credit limit</div>
                        </div>
                      </div>
                      <div className="hidden Qsmd:flex border-primary-bg border-l-border my-margin-md h-auto"></div>

                      <div className="w-width-full Qsmd:w-tl-width-2 flex Qsmd:flex-row flex-col justify-between border-t-border border-t-primary-bg Qsmd:border-none Qsmd:h-auto">
                        <div className="flex flex-col  pl-padding-base py-padding-md Qsmd:pl-padding-md Qsmd:py-padding-base  p-padding-md w-width-full justify-center border-primary-bg border-b-border Qsmd:border-none">
                          <div className="flex gap-gap-sm items-center">
                            {ownerDetailData?.account_type !==
                              "Overdraft Account" &&
                            ownerDetailData?.min_limit ? (
                              <>
                                <div
                                  className={`text-font-md font-normal text-text-primary`}
                                >
                                  INR{" "}
                                  {FormatAmount({
                                    price: ownerDetailData?.min_limit,
                                  })}
                                </div>
                                <div
                                  className={` ${props?.popType == "reimburseowner_details" ? " cursor-default opacity-light-opacity" : "cursor-pointer"}`}
                                  onClick={() => {
                                    if (
                                      props?.popType == "reimburseowner_details"
                                    ) {
                                      CommonToast({
                                        text: "Action restricted in popup mode.",
                                        icon: ICONS?.ERROR_WHITE_CIRCLE,
                                        variant: "var(--error)",
                                      });
                                    } else {
                                      setMinimumLimitInput(
                                        ownerDetailData?.min_limit ||
                                          GlobalConfiguration.lengthCheckZero,
                                      );
                                      setShowMinimumLimitPopup(true);
                                    }
                                  }}
                                  disabled={!services?.includes("UAccount")}
                                >
                                  <img
                                    src={
                                      "https://q2pay.in/new_assets/common/create_flow/edit.svg"
                                    }
                                    className="w-icon-sm h-icon-sm"
                                    alt={"edit"}
                                  />
                                </div>
                              </>
                            ) : (
                              <div className="acc-balance-content">
                                <div>N/A</div>
                              </div>
                            )}
                          </div>

                          <div className="acc-number-label">
                            Minimum balance
                          </div>
                        </div>
                        <div className="hidden Qsmd:flex border-primary-bg border-l-border my-margin-md h-auto"></div>
                        <div className="flex flex-col pl-padding-base py-padding-md Qsmd:pl-padding-md Qsmd:py-padding-base  p-padding-md w-width-full justify-center">
                          <div className="flex gap-gap-sm items-center">
                            {ownerDetailData?.account_type !==
                              "Overdraft Account" &&
                            ownerDetailData?.max_limit ? (
                              <>
                                <div
                                  className={`text-font-md font-normal text-text-primary`}
                                >
                                  INR{" "}
                                  {FormatAmount({
                                    price: ownerDetailData?.max_limit,
                                  })}
                                </div>
                                <div
                                  className={` ${props?.popType == "reimburseowner_details" ? " cursor-default opacity-light-opacity" : "cursor-pointer"}`}
                                  onClick={() => {
                                    if (
                                      props?.popType == "reimburseowner_details"
                                    ) {
                                      CommonToast({
                                        text: "Action restricted in popup mode.",
                                        icon: ICONS?.ERROR_WHITE_CIRCLE,
                                        variant: "var(--error)",
                                      });
                                    } else {
                                      setMaximumLimitInput(
                                        ownerDetailData?.max_limit ||
                                          GlobalConfiguration.lengthCheckZero,
                                      );
                                      setShowMaximumLimitPopup(true);
                                    }
                                  }}
                                  disabled={!services?.includes("UAccount")}
                                >
                                  <img
                                    src={
                                      "https://q2pay.in/new_assets/common/create_flow/edit.svg"
                                    }
                                    className="w-icon-sm h-icon-sm"
                                    alt={"edit"}
                                  />
                                </div>
                              </>
                            ) : (
                              <div className="acc-balance-content">
                                <div>N/A</div>
                              </div>
                            )}
                          </div>

                          <div className="acc-number-label">
                            Auto sweep limit
                          </div>
                        </div>
                        <div className="statement flex flex-row bg-primary-nav-act">
                          <div className="hidden Qsmd:block">
                            <TopNavSmallButton
                              btnText={
                                <>
                                  {" "}
                                  Transaction <br /> history
                                </>
                              }
                              btnType="button"
                              handleFunction={() => {
                                if (
                                  props?.popType === "ownerStatement" ||
                                  props?.popType == "reimburseowner_details"
                                ) {
                                  CommonToast({
                                    text: "Action restricted in popup mode.",
                                    icon: ICONS?.ERROR_WHITE_CIRCLE,
                                    variant: "var(--error)",
                                  });
                                } else if (
                                  !services?.includes("VBeneficiaryTxn") &&
                                  !services?.includes("VInternalTxn")
                                ) {
                                  navigate("/feature_not_assigned", {
                                    state: {
                                      unavailableService:
                                        "VBeneficiaryTxn,VInternalTxn",
                                    },
                                  });
                                } else {
                                  setShowModal(true);
                                }
                              }}
                              isDisabled={
                                props?.popType === "ownerStatement" ||
                                props?.popType == "reimburseowner_details" ||
                                (!services?.includes("VBeneficiaryTxn") &&
                                  !services?.includes("VInternalTxn"))
                              }
                              enabledTextColor="var(--text-primary)"
                              enabledBgColor="var(--primary-nav-act)"
                              isLoading={false}
                              icon={transactionHistory}
                              hoverOption="white"
                              fullWidthRequired={false}
                            />
                          </div>
                          <div className="ownerdetail-border-div hidden Qsmd:block"></div>{" "}
                          <div className=" hidden Qsmd:block bg-primary-nav-act w-width-md-2-3 h-height-full">
                            <div className="flex h-height-full">
                              <TopNavSmallButton
                                btnText={
                                  <>
                                    Linked internal <br /> account
                                  </>
                                }
                                btnType="button"
                                handleFunction={() => {
                                  if (
                                    props?.popType ==
                                      "reimburseowner_details" ||
                                    props?.popType === "ownerStatement"
                                  ) {
                                    CommonToast({
                                      text: "Action restricted in popup mode.",
                                      icon: ICONS?.ERROR_WHITE_CIRCLE,
                                      variant: "var(--error)",
                                    });
                                  } else {
                                    if (
                                      services?.includes("IVAccount") ||
                                      services?.includes("Admin")
                                    ) {
                                      if (
                                        beneViewAllAccData
                                          ?.internal_accounts?.[0]?.id
                                      ) {
                                        navigate(
                                          `/internal_account_dashboard/internal_account_view_all/internal_account_detail_page/${beneViewAllAccData?.internal_accounts?.[0]?.id}`,
                                        );
                                      } else {
                                        CommonToast({
                                          text: "Unable to get Id",
                                          icon: ICONS?.ERROR_WHITE_CIRCLE,
                                          variant: "var(--error)",
                                          btnProps: {
                                            isDisabled: false,
                                            enabledTextColor:
                                              "var(--text-primary)",
                                            enabledBgColor: "var(--primary-bg)",
                                          },
                                        });
                                      }
                                    } else if (
                                      !services?.includes("IVAccount") &&
                                      !services?.includes("Admin")
                                    ) {
                                      navigate("/feature_not_assigned", {
                                        state: {
                                          unavailableService: "IVAccount,Admin",
                                        },
                                      });
                                    }
                                  }
                                }}
                                isDisabled={
                                  props?.popType === "ownerStatement" ||
                                  props?.popType == "reimburseowner_details" ||
                                  (!services?.includes("IVAccount") &&
                                    !services?.includes("Admin"))
                                }
                                enabledTextColor="var(--text-primary)"
                                enabledBgColor="var(--primary-nav-act)"
                                isLoading={false}
                                icon={LinkedLogo}
                                hoverOption="white"
                                fullWidthRequired={false}
                              />
                            </div>
                          </div>
                          {showModal && (
                            <ReminderFlowTypeModal
                              onBeneClick={() => {
                                if (
                                  props?.popType === "ownerStatement" ||
                                  props?.popType === "reimburseowner_details"
                                ) {
                                  CommonToast({
                                    text: "Action restricted in popup mode.",
                                    icon: ICONS?.ERROR_WHITE_CIRCLE,
                                    variant: "var(--error)",
                                  });
                                  return;
                                }

                                if (!services?.includes("VBeneficiaryTxn")) {
                                  navigate("/feature_not_assigned", {
                                    state: {
                                      unavailableService: "VBeneficiaryTxn",
                                    },
                                  });
                                  return;
                                }

                                setOpenBeneHistory(true);
                              }}
                              onInternalClick={() => {
                                if (
                                  props?.popType == "ownerStatement" ||
                                  props?.popType == "reimburseowner_details"
                                ) {
                                  CommonToast({
                                    text: "Action restricted in popup mode.",
                                    icon: ICONS?.ERROR_WHITE_CIRCLE,
                                    variant: "var(--error)",
                                  });
                                  return;
                                }

                                if (!services?.includes("VInternalTxn")) {
                                  navigate("/feature_not_assigned", {
                                    state: {
                                      unavailableService: "VInternalTxn",
                                    },
                                  });
                                  return;
                                }
                                setOpenHistory(true);
                              }}
                              closePanel={() => setShowModal(false)}
                              flowType="Owner"
                            />
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="bank-details flex-col Qsmd:flex-row  Qsmd:px-padding-base">
                      <div className="accno-details pl-padding-base  items-center Qsmd:pl-padding-base justify-between Qsmd:border-t-border-base border-t-border border-t-primary-bg border-b-border border-b-primary-bg Qsmd:border-border-base mx-margin-md Qsmd:mx-margin-base">
                        <TitleSubtitlePair
                          title={formatAccountNumber(
                            ownerDetailData?.bank_acc_no,
                          )}
                          subtitle="Account number"
                          variant="md"
                          titleColor="text-primary"
                        />
                        <div className="Qsmd:pr-padding-md">
                          <CardActionableButton
                            isDisabled={!services?.includes("AFavourite")}
                            bgColor="var(--primary-bg)"
                            handleFunction={() => {
                              if (
                                props?.popType == "ownerStatement" ||
                                props?.popType == "reimburseowner_details"
                              ) {
                                CommonToast({
                                  text: "Action restricted in popup mode.",
                                  icon: ICONS?.ERROR_WHITE_CIRCLE,
                                  variant: "var(--error)",
                                });
                                return;
                              }
                              if (!services?.includes("AFavourite")) {
                                navigate("/feature_not_assigned", {
                                  state: {
                                    unavailableService: "AFavourite",
                                  },
                                });
                                return;
                              } else if (!isFavTagExist) {
                                setFavShowPopup(true);

                                return;
                              } else if (isFavTagExist) {
                                setFavShowPopup(true);
                                return;
                              }
                            }}
                            icon={isFavTagExist ? yellowStar : whiteStar}
                            title="Favourites"
                          />
                        </div>
                      </div>

                      <div className="hidden Qsmd:flex border-primary-bg border-l-border my-margin-md h-auto"></div>
                      <div className="flex Qsmd:w-tl-width-2 gap-x-gap-xl ">
                        <div
                          className={`owner-div-main flex flex-row  items-center border-primary-bg Qsmd:border-none Qsmd:py-padding-sm Qsmd:px-padding-sm justify-between  Qsmd:pl-padding-sm py-padding-sm Qlg:p-padding-base pr-padding-sm  Qlg:pl-padding-sm Qsmd:pr-padding-base mx-margin-sm Qsmd:mx-margin-base `}
                        >
                          <div
                            className={` ${props?.popType == "reimburseowner_details" && "opacity-light-opacity"}`}
                          >
                            {" "}
                            <TitleSubtitlePair
                              title={ownerDetailData?.ifsc_code}
                              subtitle="IFSC code"
                              showArrow={true}
                              isDisabled={
                                props?.popType == "reimburseowner_details" ||
                                props?.popType === "ownerStatement"
                                  ? true
                                  : false
                              }
                              hoverOption="white"
                              onClick={() => {
                                if (
                                  props?.popType == "ownerStatement" ||
                                  props?.popType == "reimburseowner_details"
                                ) {
                                  CommonToast({
                                    text: "Action restricted in popup mode.",
                                    icon: ICONS?.ERROR_WHITE_CIRCLE,
                                    variant: "var(--error)",
                                  });
                                } else if (services?.includes("VIFSC")) {
                                  setIfscShowPopup(true);
                                } else {
                                  navigate("/feature_not_assigned", {
                                    state: {
                                      unavailableService: "VIFSC",
                                    },
                                  });
                                }
                              }}
                              variant="md"
                              titleColor="text-primary"
                            />
                          </div>

                          <div className="h-[fit-content]">
                            <CommonBankLogo
                              ifsc={ownerDetailData?.ifsc_code}
                              variant="big"
                              type="pill"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className=" bg-primary-card flex Qsmd:hidden"> </div>
              <div className="text-font-sm w-width-full bg-primary-card text-left flex Qsmd:hidden text-text-primary font-semibold px-padding-md py-padding-sm border-b-border border-primary-bg">
                Quick Actions
              </div>
              <div className="w-width-full border-b-border border-primary-bg"></div>
              <div className="w-width-full flex Qsmd:hidden border-b-border border-primary-bg">
                <TopNavSmallButton
                  btnText={
                    <>
                      {" "}
                      Bank <br /> statement
                    </>
                  }
                  btnType="button"
                  imgColor="var(--text-primary)"
                  icon={view_statement}
                  enabledTextColor="var(--text-primary)"
                  enabledBgColor="var(--primary-card)"
                  hoverOption="white"
                  fullWidthRequired={true}
                  isLoading={false}
                  isDisabled={
                    props?.popType === "ownerStatement" ||
                    props?.popType == "reimburseowner_details" ||
                    (!services?.includes("VAccountBalance") &&
                      !services?.includes("Admin")) ||
                    ownerDetailData?.connected_banking !== "Y"
                  }
                  handleFunction={() => {
                    if (
                      props?.popType === "ownerStatement" ||
                      props?.popType == "reimburseowner_details"
                    ) {
                      CommonToast({
                        text: "Action restricted in popup mode.",
                        icon: ICONS?.ERROR_WHITE_CIRCLE,
                        variant: "var(--error)",
                      });
                    } else if (
                      props?.popType !== "ownerStatement" &&
                      (services?.includes("VAccountBalance") ||
                        services?.includes("Admin")) &&
                      ownerDetailData?.connected_banking === "Y"
                    ) {
                      handleViewStatement();
                    } else if (
                      !services?.includes("VAccountBalance") &&
                      !services?.includes("Admin")
                    ) {
                      navigate("/feature_not_assigned", {
                        state: {
                          unavailableService: "VAccountBalance,Admin",
                        },
                      });
                    }
                  }}
                />
                <div className="ownerdetail-border-div"></div>{" "}
                <TopNavSmallButton
                  fullWidthRequired={true}
                  enabledBgColor={"var(--primary-card)"}
                  enabledTextColor={"var(--text-primary)"}
                  hoverOption="white"
                  isDisabled={
                    props?.popType === "ownerStatement" ||
                    props?.popType == "reimburseowner_details" ||
                    (!services?.includes("VItemisedStatement") &&
                      !services?.includes("Admin")) ||
                    ownerDetailData?.connected_banking !== "Y"
                  }
                  handleFunction={() => {
                    if (
                      props?.popType == "ownerStatement" ||
                      props?.popType == "reimburseowner_details"
                    ) {
                      CommonToast({
                        text: "Action restricted in popup mode.",
                        icon: ICONS?.ERROR_WHITE_CIRCLE,
                        variant: "var(--error)",
                      });
                    } else {
                      if (
                        (services?.includes("VItemisedStatement") ||
                          services?.includes("Admin")) &&
                        ownerDetailData?.connected_banking === "Y"
                      ) {
                        setViewItemisedOpenPop(true);
                      } else if (
                        !services?.includes("VItemisedStatement") &&
                        !services?.includes("Admin")
                      ) {
                        navigate("/feature_not_assigned", {
                          state: {
                            unavailableService: "VItemisedStatement ",
                          },
                        });
                      }
                    }
                  }}
                  icon={live_statement}
                  btnText={
                    <>
                      {" "}
                      Live <br /> statement
                    </>
                  }
                />
              </div>

              <div className="w-auto flex Qsmd:hidden border-b border-primary-bg">
                <TopNavSmallButton
                  btnText={
                    <>
                      {" "}
                      Transaction <br /> history
                    </>
                  }
                  btnType="button"
                  handleFunction={() => {
                    if (
                      props?.popType === "ownerStatement" ||
                      props?.popType == "reimburseowner_details"
                    ) {
                      CommonToast({
                        text: "Action restricted in popup mode.",
                        icon: ICONS?.ERROR_WHITE_CIRCLE,
                        variant: "var(--error)",
                      });
                    } else if (
                      !services?.includes("VBeneficiaryTxn") &&
                      !services?.includes("VInternalTxn")
                    ) {
                      navigate("/feature_not_assigned", {
                        state: {
                          unavailableService: "VBeneficiaryTxn,VInternalTxn",
                        },
                      });
                    } else {
                      setShowModal(true);
                    }
                  }}
                  isDisabled={
                    props?.popType === "ownerStatement" ||
                    props?.popType == "reimburseowner_details" ||
                    (!services?.includes("VBeneficiaryTxn") &&
                      !services?.includes("VInternalTxn"))
                  }
                  enabledTextColor="var(--text-primary)"
                  enabledBgColor="var(--primary-card)"
                  isLoading={false}
                  icon={transactionHistory}
                  hoverOption="white"
                  fullWidthRequired={true}
                />
                <div className="ownerdetail-border-div"></div>{" "}
                <TopNavSmallButton
                  btnText={
                    <>
                      {" "}
                      Linked internal <br /> account
                    </>
                  }
                  btnType="button"
                  handleFunction={() => {
                    if (
                      props?.popType == "reimburseowner_details" ||
                      props?.popType === "ownerStatement"
                    ) {
                      CommonToast({
                        text: "Action restricted in popup mode.",
                        icon: ICONS?.ERROR_WHITE_CIRCLE,
                        variant: "var(--error)",
                      });
                    } else {
                      if (
                        services?.includes("IVAccount") ||
                        services?.includes("Admin")
                      ) {
                        if (beneViewAllAccData?.internal_accounts?.[0]?.id) {
                          navigate(
                            `/internal_account_dashboard/internal_account_view_all/internal_account_detail_page/${beneViewAllAccData?.internal_accounts?.[0]?.id}`,
                          );
                        } else {
                          CommonToast({
                            text: "Unable to get Id",
                            icon: ICONS?.ERROR_WHITE_CIRCLE,
                            variant: "var(--error)",
                            btnProps: {
                              isDisabled: false,
                              enabledTextColor: "var(--text-primary)",
                              enabledBgColor: "var(--primary-bg)",
                            },
                          });
                        }
                      } else if (
                        !services?.includes("IVAccount") &&
                        !services?.includes("Admin")
                      ) {
                        navigate("/feature_not_assigned", {
                          state: { unavailableService: "IVAccount,Admin" },
                        });
                      }
                    }
                  }}
                  isDisabled={
                    props?.popType == "reimburseowner_details" ||
                    props?.popType === "ownerStatement"
                      ? true
                      : !(
                          services?.includes("IVAccount") ||
                          services?.includes("Admin")
                        )
                  }
                  enabledTextColor="var(--text-primary)"
                  enabledBgColor="var(--primary-card)"
                  isLoading={false}
                  icon={LinkedLogo}
                  hoverOption="white"
                  fullWidthRequired={true}
                />
              </div>
              <div className=" flex Qsmd:hidden border-b border-primary-bg">
                {showModal && (
                  <ReminderFlowTypeModal
                    onBeneClick={() => {
                      if (
                        props?.popType === "ownerStatement" ||
                        props?.popType === "reimburseowner_details"
                      ) {
                        CommonToast({
                          text: "Action restricted in popup mode.",
                          icon: ICONS?.ERROR_WHITE_CIRCLE,
                          variant: "var(--error)",
                        });
                        return;
                      }

                      if (!services?.includes("VBeneficiaryTxn")) {
                        navigate("/feature_not_assigned", {
                          state: {
                            unavailableService: "VBeneficiaryTxn",
                          },
                        });
                        return;
                      }

                      setOpenBeneHistory(true);
                    }}
                    onInternalClick={() => {
                      if (
                        props?.popType == "ownerStatement" ||
                        props?.popType == "reimburseowner_details"
                      ) {
                        CommonToast({
                          text: "Action restricted in popup mode.",
                          icon: ICONS?.ERROR_WHITE_CIRCLE,
                          variant: "var(--error)",
                        });
                        return;
                      }

                      if (!services?.includes("VInternalTxn")) {
                        navigate("/feature_not_assigned", {
                          state: {
                            unavailableService: "VInternalTxn",
                          },
                        });
                        return;
                      }
                      setOpenHistory(true);
                    }}
                    closePanel={() => setShowModal(false)}
                    flowType="Owner"
                  />
                )}
              </div>
              <div className="details-div-section w-screen">
                <div className="detail-section-trans h-auto m-auto max-w-tab-width-normal">
                  <div className="flex pt-padding-md px-padding-md lg:px-padding-base">
                    <div className="flex switch-tab-parent gap-gap-sm bg-primary-card rounded-border-radius-md w-auto Qsm:overflow-x-hidden ">
                      <SwitcherTabs
                        tabs={[
                          {
                            label: "Details",
                            key: "details",
                            handler: toggleDetails,
                          },
                          {
                            label: "Statistics",
                            key: "statistics",
                            handler: handleStatistics,
                            isDisabled: !(
                              ownerDetailData?.connected_banking === "Y" &&
                              (services?.includes("Admin") ||
                                services?.includes("VAccountBalance"))
                            ),
                          },
                          {
                            label: "Tags",
                            key: "assigned_tags",
                            handler: toggleAdditionalDetails,
                          },
                          {
                            label: "Labels",
                            key: "labels",
                            handler: toggleLabelDetails,
                          },
                        ]}
                        initialActiveTab={
                          showDetails
                            ? "details"
                            : showStatistics
                              ? "statistics"
                              : showAssignedTags
                                ? "assigned_tags"
                                : "labels"
                        }
                        setIndex={setIndex}
                      />
                    </div>
                  </div>
                  {index === GlobalConfiguration?.lengthCheckZero &&
                    showDetails && (
                      <div className={animationClass}>
                        <div
                          key={ownerDetailData?.id}
                          className="flex flex-col Qsmd:flex-row my-margin-md px-padding-md lg:px-padding-base gap-gap-md"
                        >
                          <CommonDetailCard
                            cardTitle="Bank Details"
                            numCols={GlobalConfiguration?.lengthCheckOne}
                            variant="third"
                            entries={bankDetailsEntries}
                          />

                          <CommonDetailCard
                            cardTitle="Owner Details"
                            numCols={GlobalConfiguration?.lengthCheckOne}
                            variant="third"
                            entries={ownerDetailsEntries}
                          />

                          <CommonDetailCard
                            cardTitle="Support Information"
                            numCols={GlobalConfiguration?.lengthCheckOne}
                            variant="third"
                            entries={supportDetailsEntries}
                          />
                        </div>
                      </div>
                    )}
                  {index === GlobalConfiguration?.lengthCheckOne &&
                    showStatistics && (
                      <div className={animationClass}>
                        <div className="px-padding-md lg:px-padding-base statistics-card-row">
                          <div className="statistics-user-message">
                            Missed potential income is calculated only for the
                            days the bank statement is available.
                          </div>
                          <div className="statistics-first-card flex flex-col-reverse Qsmd:flex-row w-width-full">
                            <div className="statistics-first-card-left relative flex flex-col min-h-graphic-square-height-lg flex-shrink-0 w-width-full border-r-border-base Qsmd:border-r border-primary-bg Qsmd:w-width-md-2-3 mt-margin-md Qsmd:mt-margin-base">
                              <p className="statistics-second-card-p1">
                                Missed potential income for last 7 days
                              </p>
                              <p
                                className={`statistics-second-card-p2 pb-padding-md`}
                              >
                                Income that could have been generated if the
                                idle amount had been invested through Xpentra.
                              </p>

                              <div className="statistics-first-card-left-div flex flex-1 items-center justify-center">
                                {getOwnerAccWeekStatiticsLoading ? (
                                  <div className="statistics-graph-no-data">
                                    <SVGComponent
                                      url={
                                        "https://q2pay.in/new_assets/gifs/inputloader_white.gif"
                                      }
                                      height={"var(--icon-lg)"}
                                      width={"var(--icon-lg)"}
                                    />
                                  </div>
                                ) : (
                                  <div className="w-full">
                                    {accountBalancesReportWeekData?.length >
                                    GlobalConfiguration?.lengthCheckZero ? (
                                      <>
                                        <OwnerStatisticsGraph
                                          missedIncomeGraphData={
                                            missedIncomeGraphData
                                          }
                                          actualIncomeGraphData={
                                            actualIncomeGraphData
                                          }
                                          amountRangeValue={amountRangeValue}
                                          pastSevenDays={pastSevenDays}
                                        />
                                        <div className="text-center text-text-primary text-font-sm">
                                          Last 7 days
                                        </div>
                                      </>
                                    ) : (
                                      <div className="statistics-graph-no-data">
                                        <div>
                                          <SVGComponent
                                            url={
                                              "https://q2pay.in/new_assets/graphics/no_data/no_statistics_available.svg"
                                            }
                                            height={
                                              "var(--graphic-square-height-md)"
                                            }
                                            width={"var(--graphic-width-md)"}
                                          />
                                          <div className="statistics-graph-no-data-text text-wrap">
                                            {accountBalancesReportWeekError}
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                )}
                              </div>
                            </div>
                            <div className="pl-padding-base Qsmd:pl-padding-md flex flex-col statistics-first-card-right relative Qsmd:w-width-sm-1-3 w-width-full">
                              <div className="statistics-first-card-right-div">
                                <p className="statistics-first-card-right-text">
                                  Amount range
                                </p>
                                <div className="statistics-first-card-right-dropdown">
                                  <SingleSelectDropDownComponent
                                    type="small"
                                    options={[
                                      "Absolute (amount)",
                                      "Amount in lakhs",
                                      "Amount in crores",
                                      "Amount in millions",
                                      "Amount in billions",
                                    ]}
                                    selected={amountRange}
                                    setSelected={(value) => {
                                      if (!value || value === "") {
                                        setAmountRange("Absolute (amount)");
                                        setAmountRangeValue("");
                                        return;
                                      }

                                      setAmountRange(value);

                                      if (value === "Absolute (amount)")
                                        setAmountRangeValue("");
                                      else if (value === "Amount in lakhs")
                                        setAmountRangeValue("Lakhs");
                                      else if (value === "Amount in crores")
                                        setAmountRangeValue("Crores");
                                      else if (value === "Amount in millions")
                                        setAmountRangeValue("Millions");
                                      else if (value === "Amount in billions")
                                        setAmountRangeValue("Billions");
                                    }}
                                    showSearch={false}
                                    isOpen={selectAmountRange}
                                    placeholder="Select type"
                                  />
                                </div>
                                <div
                                  style={{
                                    borderBottom:
                                      "var(--border) solid var(--primary-card)",
                                    marginTop: "var(--margin-md)",
                                  }}
                                ></div>
                              </div>

                              {/* <div className="mt-margin-sm">
                                <p className="statistics-first-card-right-text">
                                  Investment schemes
                                </p>
                                <div>
                                  <OwnerAccStatisticsDropdown
                                    setInvestmentRate={setInvestmentRate}
                                    investmentRate={investmentRate}
                                    selectInvestmentRate={selectInvestmentRate}
                                    setSelectInvestmentRate={
                                      setSelectInvestmentRate
                                    }
                                    setInvestmentRateValue={
                                      setInvestmentRateValue
                                    }
                                    investmentRateValue={investmentRateValue}
                                    setInfoState={setInfoState}
                                    type="investment"
                                  />
                                </div>
                               </div> */}
                              <div className="flex flex-col justify-between flex-1">
                                <div>
                                  <div className="flex flex-row">
                                    <span className=" text-queued text-font-md font-semibold relative">
                                      INR{" "}
                                      {
                                        formatTotalBalance(
                                          accountBalancesReportWeekAllData?.accrued_interest_amount ||
                                            GlobalConfiguration?.lengthCheckZero,
                                          amountRangeValue !== ""
                                            ? amountRangeValue
                                            : "amount",
                                        ).amount
                                      }
                                    </span>{" "}
                                    <div
                                      onClick={() => {
                                        setInfoState(!infoState);
                                      }}
                                      ref={infoRef}
                                      className="ml-margin-xs cursor-pointer"
                                    >
                                      <SVGComponent
                                        url={
                                          "https://q2pay.in/new_assets/common/detail_page/info.svg"
                                        }
                                        height={"var(--icon-sm)"}
                                        width={"var(--icon-sm)"}
                                      />
                                    </div>
                                    {infoState ? (
                                      <div className="absolute mt-margin-lg text-font-xs text-text-primary bg-primary-nav-act rounded-border-radius-sm px-padding-md py-padding-md z-z-index-content">
                                        This amount is based on the interest
                                        that could have earned by auto-investing
                                        using Xpentra, calculated at 6.5% of the
                                        idle funds.
                                      </div>
                                    ) : null}
                                  </div>
                                  <p className="text-font-xs text-text-primary">
                                    Total missed potential income
                                  </p>
                                </div>

                                <div className="flex Qsmd:flex-col gap-gap-md Qsmd:gap-gap-base mt-margin-md Qsmd:mt-margin-base">
                                  <div className="flex flex-row mb-margin-base Qsmd:mb-margin-sm items-center">
                                    <div className="w-icon-md h-icon-md bg-custom-red rounded-border-radius-xs"></div>
                                    <p className="ml-margin-sm text-text-primary text-font-xs font-semibold">
                                      Actual income
                                    </p>
                                  </div>
                                  <div className="flex flex-row items-center">
                                    <div className="w-icon-md h-icon-md bg-queued rounded-border-radius-xs"></div>
                                    <p className="ml-margin-sm text-text-primary text-font-xs font-semibold">
                                      Missed potential income*
                                    </p>
                                  </div>
                                  <div className="mt-margin-sm Qsmd:flex hidden">
                                    <p className="text-text-secondary text-font-xs font-normal">
                                      * Amounts rounded off as per banking
                                      standards.
                                    </p>
                                  </div>
                                </div>
                                <div className="mt-margin-sm Qsmd:hidden flex">
                                  <p className="text-text-secondary text-font-xs font-normal">
                                    * Amounts rounded off as per banking
                                    standards.
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className={`assigned-card-row px-padding-md lg:px-padding-base pb-padding-md`}
                        >
                          <div
                            className="statistics-second-card"
                            style={{ height: "auto" }}
                          >
                            <div className="bg-primary-nav rounded-t-border-radius-md">
                              <div className="statistics-second-card-top-bar flex flex-col Qsmd:flex-row">
                                <div className="statistics-second-card-summary">
                                  <p className="statistics-second-card-p1">
                                    Balance summary
                                  </p>
                                  <p className="statistics-second-card-p2">
                                    Daily balance summary of this account
                                  </p>
                                </div>
                                <div>
                                  <div className="relative pb-padding-xs">
                                    <div className="pt-padding-md Qsmd:pt-padding-base flex justify-end">
                                      <CommonCalendar
                                        startDate={startDateState}
                                        endDate={endDateState}
                                        handleDateChange={handleDateChange2}
                                        type="small"
                                        selectionType="range"
                                      />
                                    </div>
                                  </div>
                                  <div className="statistics-date-note">
                                    Start and end dates must be within a 6-month
                                    period.
                                  </div>
                                </div>
                              </div>
                              <div className="border border-primary-bg mx-margin-md"></div>
                              <div className="statistics-second-card-middle-bar gap-gap-md flex flex-col Qsmd:flex-row">
                                <div>
                                  <p className="statistics-second-card-p1-total">
                                    Total missed potential income
                                  </p>
                                  <p className="statistics-second-card-p3">
                                    From{" "}
                                    {formatDate(startDate, true, false, true)}{" "}
                                    to {formatDate(endDate, true, false, true)}
                                  </p>
                                </div>
                                <div className="relative">
                                  <span className="statistics-second-card-span absolute Qsmd:right-right-base">
                                    INR{" "}
                                    {
                                      formatTotalBalance(
                                        accountBalancesReportAllData?.accrued_interest_amount ||
                                          GlobalConfiguration?.lengthCheckZero,
                                        amountRangeValue !== ""
                                          ? amountRangeValue
                                          : "amount",
                                      ).amount
                                    }
                                  </span>
                                  <div className="mt-margin-md">
                                    <p className="text-text-secondary text-font-xs font-normal">
                                      * Amounts rounded off as per banking
                                      standards.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="statistics-second-card-header-bar grid grid-cols-5">
                              <div className="p-padding-sm Qsmd:p-padding-md">
                                Date
                              </div>
                              <div className="statistics-second-card-header-bar-div2 py-padding-md">
                                Closing balance
                              </div>
                              <div className="p-padding-sm Qsmd:p-padding-md">
                                Minimum balance
                              </div>
                              <div className="statistics-second-card-header-bar-div2 py-padding-md">
                                Idle funds
                              </div>
                              <div className="p-padding-sm Qsmd:p-padding-md">
                                Missed potential income
                              </div>
                            </div>
                            <div
                              className="statistics-second-card-data-div"
                              style={{
                                overflowY:
                                  accountBalancesReportData?.length >
                                  GlobalConfiguration?.lengthCheckZero
                                    ? "auto"
                                    : "hidden",
                              }}
                            >
                              {getOwnerAccStatiticsLoading ? (
                                <>
                                  <div className="statistics-graph-no-data mt-margin-xl">
                                    <SVGComponent
                                      url={
                                        "https://q2pay.in/new_assets/gifs/inputloader_white.gif"
                                      }
                                      height={"var(--icon-lg)"}
                                      width={"var(--icon-lg)"}
                                    />
                                  </div>
                                </>
                              ) : (
                                <>
                                  {accountBalancesReportData?.length >
                                  GlobalConfiguration?.lengthCheckZero ? (
                                    accountBalancesReportData.map(
                                      (data, index) => {
                                        return (
                                          <div
                                            className="statistics-second-card-data-bars"
                                            style={{
                                              borderBottom:
                                                accountBalancesReportData?.length -
                                                  GlobalConfiguration?.lengthCheckOne ===
                                                index
                                                  ? ""
                                                  : "var(--border) solid var(--primary-bg)",
                                            }}
                                          >
                                            <div className="statistics-second-card-data-div-date">
                                              {formatDate(
                                                data?.date,
                                                false,
                                                true,
                                              )}
                                            </div>
                                            <div className="statistics-second-card-data-div-amount1">
                                              INR{" "}
                                              {
                                                formatTotalBalance(
                                                  Number(data?.closing_balance),
                                                  amountRangeValue !== ""
                                                    ? amountRangeValue
                                                    : "amount",
                                                ).amount
                                              }
                                            </div>
                                            <div className="statistics-second-card-data-div-amount2">
                                              INR 0.00
                                            </div>
                                            <div className="statistics-second-card-data-div-amount3">
                                              INR{" "}
                                              {
                                                formatTotalBalance(
                                                  Number(data?.closing_balance),
                                                  amountRangeValue !== ""
                                                    ? amountRangeValue
                                                    : "amount",
                                                ).amount
                                              }
                                            </div>
                                            <div className="statistics-second-card-data-div-income">
                                              INR{" "}
                                              {
                                                formatTotalBalance(
                                                  Number(data?.daily_interest),
                                                  amountRangeValue !== ""
                                                    ? amountRangeValue
                                                    : "amount",
                                                ).amount
                                              }
                                            </div>
                                          </div>
                                        );
                                      },
                                    )
                                  ) : (
                                    <div className="statistics-second-card-no-data">
                                      <div>
                                        <SVGComponent
                                          url={
                                            "https://q2pay.in/new_assets/graphics/no_data/no_statistics_available.svg"
                                          }
                                          height={
                                            "var(--graphic-square-height-md)"
                                          }
                                          width={"var(--graphic-width-md)"}
                                        />
                                        <div className="statistics-second-card-no-data-text text-wrap">
                                          {accountBalancesReportError}
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  {index === GlobalConfiguration?.lengthCheckTwo &&
                    showAssignedTags && (
                      <div className={animationClass}>
                        <div className="mt-margin-md pb-padding-md">
                          <CommonContainerCard
                            header="Tags"
                            subheader={TEXT?.TAG_INSTRUCTION}
                            iconIsDisabled={
                              props?.popType == "reimburseowner_details"
                                ? true
                                : false
                            }
                            icon={
                              "https://q2pay.in/new_assets/common/create_flow/edit.svg"
                            }
                            handleFunction={() => {
                              if (
                                props?.popType == "ownerStatement" ||
                                props?.popType == "reimburseowner_details"
                              ) {
                                CommonToast({
                                  text: "Action restricted in popup mode.",
                                  icon: ICONS?.ERROR_WHITE_CIRCLE,
                                  variant: "var(--error)",
                                });
                              } else if (
                                !services?.includes("COwnerTag") &&
                                !services?.includes("DOwnerTag")
                              ) {
                                navigate("/feature_not_assigned");
                              } else {
                                {
                                  handleSelectedtag();
                                }
                              }
                            }}
                          >
                            <div className="flex flex-row gap-gap-sm flex-wrap">
                              {haveName ? (
                                newTags
                                  ?.filter((tag) => tag.type === "ownerTags")
                                  ?.map((tag) => {
                                    return (
                                      <>
                                        <Chips
                                          txtChip={tag?.value}
                                          enabledBgColor="var(--primary-nav)"
                                          enabledTextColor="var(--text-primary)"
                                          isTickerRequired={true}
                                        />
                                      </>
                                    );
                                  })
                              ) : (
                                <p className="NotagsAssigned">
                                  No tags assigned to this account.
                                </p>
                              )}
                            </div>
                          </CommonContainerCard>
                        </div>
                      </div>
                    )}
                  {index === GlobalConfiguration?.lengthCheckThree && (
                    <div className={animationClass}>
                      <div className="mt-margin-md pb-padding-md">
                        <CommonContainerCard
                          header="Labels"
                          subheader={TEXT?.LABELS_STATS_USAGE_NOTE}
                          iconIsDisabled={
                            props?.popType == "reimburseowner_details"
                              ? true
                              : false
                          }
                          icon={
                            "https://q2pay.in/new_assets/common/create_flow/edit.svg"
                          }
                          handleFunction={handleClick}
                        >
                          <div className="flex flex-wrap w-width-full gap-gap-sm">
                            {Array.isArray(labelDetails) &&
                            labelDetails.length >
                              GlobalConfiguration?.lengthCheckZero ? (
                              <>
                                {labelDetails.map((item, index) => (
                                  <Chips
                                    txtChip={item}
                                    enabledBgColor="var(--primary-nav)"
                                    enabledTextColor="var(--text-primary)"
                                    isTickerRequired={true}
                                  />
                                ))}
                              </>
                            ) : (
                              <p className="text-font-sm text-text-primary">
                                No labels assigned.
                              </p>
                            )}
                          </div>
                        </CommonContainerCard>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
}

export default OwnerDetailsPage;
